var At = Object.defineProperty;
var It = (e, t, r) => t in e ? At(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var E = (e, t, r) => (It(e, typeof t != "symbol" ? t + "" : t, r), r), se = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
};
var B = (e, t, r) => (se(e, t, "read from private field"), r ? r.call(e) : t.get(e)), ne = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, xe = (e, t, r, s) => (se(e, t, "write to private field"), s ? s.call(e, r) : t.set(e, r), r);
var z = (e, t, r) => (se(e, t, "access private method"), r);
import { r as le, a as Re, c as Mt, b as ze } from "./release-BueoVUqq.js";
var Ot = /(%?)(%([sdijo]))/g;
function qt(e, t) {
  switch (t) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const r = JSON.stringify(e);
      return r === "{}" || r === "[]" || /^\[object .+?\]$/.test(r) ? e : r;
    }
  }
}
function ve(e, ...t) {
  if (t.length === 0)
    return e;
  let r = 0, s = e.replace(
    Ot,
    (n, o, a, u) => {
      const i = t[r], c = qt(i, u);
      return o ? n : (r++, c);
    }
  );
  return r < t.length && (s += ` ${t.slice(r).join(" ")}`), s = s.replace(/%{2,2}/g, "%"), s;
}
var jt = 2;
function Nt(e) {
  if (!e.stack)
    return;
  const t = e.stack.split(`
`);
  t.splice(1, jt), e.stack = t.join(`
`);
}
var $t = class extends Error {
  constructor(t, ...r) {
    super(t), this.message = t, this.name = "Invariant Violation", this.message = ve(t, ...r), Nt(this);
  }
}, X = (e, t, ...r) => {
  if (!e)
    throw new $t(t, ...r);
};
X.as = (e, t, r, ...s) => {
  if (!t) {
    const n = s.length === 0 ? r : ve(r, s);
    let o;
    try {
      o = Reflect.construct(e, [n]);
    } catch {
      o = e(n);
    }
    throw o;
  }
};
const Dt = "[MSW]";
function ye(e, ...t) {
  const r = ve(e, ...t);
  return `${Dt} ${r}`;
}
function Ut(e, ...t) {
  console.warn(ye(e, ...t));
}
function Ht(e, ...t) {
  console.error(ye(e, ...t));
}
const k = {
  formatMessage: ye,
  warn: Ut,
  error: Ht
}, Bt = /[\/\\]msw[\/\\]src[\/\\](.+)/, Wt = /(node_modules)?[\/\\]lib[\/\\](core|browser|node|native|iife)[\/\\]|^[^\/\\]*$/;
function Ft(e) {
  const t = e.stack;
  if (!t)
    return;
  const s = t.split(`
`).slice(1).find((o) => !(Bt.test(o) || Wt.test(o)));
  return s ? s.replace(/\s*at [^()]*\(([^)]+)\)/, "$1").replace(/^@/, "") : void 0;
}
function Gt(e) {
  return e ? typeof e[Symbol.iterator] == "function" : !1;
}
const V = class V {
  constructor(t) {
    E(this, "info");
    /**
     * Indicates whether this request handler has been used
     * (its resolver has successfully executed).
     */
    E(this, "isUsed");
    E(this, "resolver");
    E(this, "resolverGenerator");
    E(this, "resolverGeneratorResult");
    E(this, "options");
    this.resolver = t.resolver, this.options = t.options;
    const r = Ft(new Error());
    this.info = {
      ...t.info,
      callFrame: r
    }, this.isUsed = !1;
  }
  /**
   * Parse the intercepted request to extract additional information from it.
   * Parsed result is then exposed to other methods of this request handler.
   */
  async parse(t) {
    return {};
  }
  /**
   * Test if this handler matches the given request.
   *
   * This method is not used internally but is exposed
   * as a convenience method for consumers writing custom
   * handlers.
   */
  async test(t) {
    const r = await this.parse({
      request: t.request,
      resolutionContext: t.resolutionContext
    });
    return this.predicate({
      request: t.request,
      parsedResult: r,
      resolutionContext: t.resolutionContext
    });
  }
  extendResolverArgs(t) {
    return {};
  }
  // Clone the request instance before it's passed to the handler phases
  // and the response resolver so we can always read it for logging.
  // We only clone it once per request to avoid unnecessary overhead.
  cloneRequestOrGetFromCache(t) {
    const r = V.cache.get(t);
    if (typeof r < "u")
      return r;
    const s = t.clone();
    return V.cache.set(t, s), s;
  }
  /**
   * Execute this request handler and produce a mocked response
   * using the given resolver function.
   */
  async run(t) {
    var l, h;
    if (this.isUsed && ((l = this.options) != null && l.once))
      return null;
    const r = this.cloneRequestOrGetFromCache(t.request), s = await this.parse({
      request: t.request,
      resolutionContext: t.resolutionContext
    });
    if (!this.predicate({
      request: t.request,
      parsedResult: s,
      resolutionContext: t.resolutionContext
    }) || this.isUsed && ((h = this.options) != null && h.once))
      return null;
    this.isUsed = !0;
    const o = this.wrapResolver(this.resolver), a = this.extendResolverArgs({
      request: t.request,
      parsedResult: s
    }), i = await o({
      ...a,
      requestId: t.requestId,
      request: t.request
    }).catch((d) => {
      if (d instanceof Response)
        return d;
      throw d;
    });
    return this.createExecutionResult({
      // Pass the cloned request to the result so that logging
      // and other consumers could read its body once more.
      request: r,
      requestId: t.requestId,
      response: i,
      parsedResult: s
    });
  }
  wrapResolver(t) {
    return async (r) => {
      const s = this.resolverGenerator || await t(r);
      if (Gt(s)) {
        this.isUsed = !1;
        const { value: n, done: o } = s[Symbol.iterator]().next(), a = await n;
        return o && (this.isUsed = !0), !a && o ? (X(
          this.resolverGeneratorResult,
          "Failed to returned a previously stored generator response: the value is not a valid Response."
        ), this.resolverGeneratorResult.clone()) : (this.resolverGenerator || (this.resolverGenerator = s), a && (this.resolverGeneratorResult = a == null ? void 0 : a.clone()), a);
      }
      return s;
    };
  }
  createExecutionResult(t) {
    return {
      handler: this,
      request: t.request,
      requestId: t.requestId,
      response: t.response,
      parsedResult: t.parsedResult
    };
  }
};
E(V, "cache", /* @__PURE__ */ new WeakMap());
let Z = V;
var Vt = async (e) => {
  try {
    return { error: null, data: await e().catch((r) => {
      throw r;
    }) };
  } catch (t) {
    return { error: t, data: null };
  }
};
const Xt = async ({
  request: e,
  requestId: t,
  handlers: r,
  resolutionContext: s
}) => {
  let n = null, o = null;
  for (const a of r)
    if (o = await a.run({ request: e, requestId: t, resolutionContext: s }), o !== null && (n = a), o != null && o.response)
      break;
  return n ? {
    handler: n,
    parsedResult: o == null ? void 0 : o.parsedResult,
    response: o == null ? void 0 : o.response
  } : null;
};
function Ye(e) {
  if (typeof location > "u")
    return e.toString();
  const t = e instanceof URL ? e : new URL(e);
  return t.origin === location.origin ? t.pathname : t.origin + t.pathname;
}
async function Jt(e, t = "warn") {
  const r = new URL(e.url), s = Ye(r), n = `intercepted a request without a matching request handler:

  • ${e.method} ${s}

If you still wish to intercept this unhandled request, please create a request handler for it.
Read more: https://mswjs.io/docs/getting-started/mocks`;
  function o(a) {
    switch (a) {
      case "error":
        throw k.error("Error: %s", n), new Error(
          k.formatMessage(
            'Cannot bypass a request when using the "error" strategy for the "onUnhandledRequest" option.'
          )
        );
      case "warn": {
        k.warn("Warning: %s", n);
        break;
      }
      case "bypass":
        break;
      default:
        throw new Error(
          k.formatMessage(
            'Failed to react to an unhandled request: unknown strategy "%s". Please provide one of the supported strategies ("bypass", "warn", "error") or a custom callback function as the value of the "onUnhandledRequest" option.',
            a
          )
        );
    }
  }
  if (typeof t == "function") {
    t(e, {
      warning: o.bind(null, "warn"),
      error: o.bind(null, "error")
    });
    return;
  }
  r.protocol !== "file:" && o(t);
}
var zt = Object.create, Ze = Object.defineProperty, Yt = Object.getOwnPropertyDescriptor, Ke = Object.getOwnPropertyNames, Zt = Object.getPrototypeOf, Kt = Object.prototype.hasOwnProperty, Qt = (e, t) => function() {
  return t || (0, e[Ke(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, er = (e, t, r, s) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Ke(t))
      !Kt.call(e, n) && n !== r && Ze(e, n, { get: () => t[n], enumerable: !(s = Yt(t, n)) || s.enumerable });
  return e;
}, tr = (e, t, r) => (r = e != null ? zt(Zt(e)) : {}, er(
  t || !e || !e.__esModule ? Ze(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), rr = Qt({
  "node_modules/set-cookie-parser/lib/set-cookie.js"(e, t) {
    var r = {
      decodeValues: !0,
      map: !1,
      silent: !1
    };
    function s(i) {
      return typeof i == "string" && !!i.trim();
    }
    function n(i, c) {
      var l = i.split(";").filter(s), h = l.shift(), d = o(h), g = d.name, p = d.value;
      c = c ? Object.assign({}, r, c) : r;
      try {
        p = c.decodeValues ? decodeURIComponent(p) : p;
      } catch (m) {
        console.error(
          "set-cookie-parser encountered an error while decoding a cookie with value '" + p + "'. Set options.decodeValues to false to disable this feature.",
          m
        );
      }
      var f = {
        name: g,
        value: p
      };
      return l.forEach(function(m) {
        var v = m.split("="), y = v.shift().trimLeft().toLowerCase(), S = v.join("=");
        y === "expires" ? f.expires = new Date(S) : y === "max-age" ? f.maxAge = parseInt(S, 10) : y === "secure" ? f.secure = !0 : y === "httponly" ? f.httpOnly = !0 : y === "samesite" ? f.sameSite = S : f[y] = S;
      }), f;
    }
    function o(i) {
      var c = "", l = "", h = i.split("=");
      return h.length > 1 ? (c = h.shift(), l = h.join("=")) : l = i, { name: c, value: l };
    }
    function a(i, c) {
      if (c = c ? Object.assign({}, r, c) : r, !i)
        return c.map ? {} : [];
      if (i.headers)
        if (typeof i.headers.getSetCookie == "function")
          i = i.headers.getSetCookie();
        else if (i.headers["set-cookie"])
          i = i.headers["set-cookie"];
        else {
          var l = i.headers[Object.keys(i.headers).find(function(d) {
            return d.toLowerCase() === "set-cookie";
          })];
          !l && i.headers.cookie && !c.silent && console.warn(
            "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
          ), i = l;
        }
      if (Array.isArray(i) || (i = [i]), c = c ? Object.assign({}, r, c) : r, c.map) {
        var h = {};
        return i.filter(s).reduce(function(d, g) {
          var p = n(g, c);
          return d[p.name] = p, d;
        }, h);
      } else
        return i.filter(s).map(function(d) {
          return n(d, c);
        });
    }
    function u(i) {
      if (Array.isArray(i))
        return i;
      if (typeof i != "string")
        return [];
      var c = [], l = 0, h, d, g, p, f;
      function m() {
        for (; l < i.length && /\s/.test(i.charAt(l)); )
          l += 1;
        return l < i.length;
      }
      function v() {
        return d = i.charAt(l), d !== "=" && d !== ";" && d !== ",";
      }
      for (; l < i.length; ) {
        for (h = l, f = !1; m(); )
          if (d = i.charAt(l), d === ",") {
            for (g = l, l += 1, m(), p = l; l < i.length && v(); )
              l += 1;
            l < i.length && i.charAt(l) === "=" ? (f = !0, l = p, c.push(i.substring(h, g)), h = l) : l = g + 1;
          } else
            l += 1;
        (!f || l >= i.length) && c.push(i.substring(h, i.length));
      }
      return c;
    }
    t.exports = a, t.exports.parse = a, t.exports.parseString = n, t.exports.splitCookiesString = u;
  }
}), Se = tr(rr()), $ = "MSW_COOKIE_STORE";
function _e() {
  try {
    if (localStorage == null)
      return !1;
    const e = $ + "_test";
    return localStorage.setItem(e, "test"), localStorage.getItem(e), localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
}
function Le(e, t) {
  try {
    return e[t], !0;
  } catch {
    return !1;
  }
}
var sr = class {
  constructor() {
    this.store = /* @__PURE__ */ new Map();
  }
  add(e, t) {
    if (Le(e, "credentials") && e.credentials === "omit")
      return;
    const r = new URL(e.url), s = t.headers.get("set-cookie");
    if (!s)
      return;
    const n = Date.now(), o = (0, Se.parse)(s).map(
      ({ maxAge: u, ...i }) => ({
        ...i,
        expires: u === void 0 ? i.expires : new Date(n + u * 1e3),
        maxAge: u
      })
    ), a = this.store.get(r.origin) || /* @__PURE__ */ new Map();
    o.forEach((u) => {
      this.store.set(r.origin, a.set(u.name, u));
    });
  }
  get(e) {
    this.deleteExpiredCookies();
    const t = new URL(e.url), r = this.store.get(t.origin) || /* @__PURE__ */ new Map();
    if (!Le(e, "credentials"))
      return r;
    switch (e.credentials) {
      case "include":
        return typeof document > "u" || (0, Se.parse)(document.cookie).forEach((n) => {
          r.set(n.name, n);
        }), r;
      case "same-origin":
        return r;
      default:
        return /* @__PURE__ */ new Map();
    }
  }
  getAll() {
    return this.deleteExpiredCookies(), this.store;
  }
  deleteAll(e) {
    const t = new URL(e.url);
    this.store.delete(t.origin);
  }
  clear() {
    this.store.clear();
  }
  hydrate() {
    if (!_e())
      return;
    const e = localStorage.getItem($);
    if (e)
      try {
        JSON.parse(e).forEach(([r, s]) => {
          this.store.set(
            r,
            new Map(
              s.map(([n, { expires: o, ...a }]) => [
                n,
                o === void 0 ? a : { ...a, expires: new Date(o) }
              ])
            )
          );
        });
      } catch (t) {
        console.warn(`
[virtual-cookie] Failed to parse a stored cookie from the localStorage (key "${$}").

Stored value:
${localStorage.getItem($)}

Thrown exception:
${t}

Invalid value has been removed from localStorage to prevent subsequent failed parsing attempts.`), localStorage.removeItem($);
      }
  }
  persist() {
    if (!_e())
      return;
    const e = Array.from(this.store.entries()).map(
      ([t, r]) => [t, Array.from(r.entries())]
    );
    localStorage.setItem($, JSON.stringify(e));
  }
  deleteExpiredCookies() {
    const e = Date.now();
    this.store.forEach((t, r) => {
      t.forEach(({ expires: s, name: n }) => {
        s !== void 0 && s.getTime() <= e && t.delete(n);
      }), t.size === 0 && this.store.delete(r);
    });
  }
}, K = new sr();
function nr(e, t) {
  K.add({ ...e, url: e.url.toString() }, t), K.persist();
}
async function Qe(e, t, r, s, n, o) {
  var l, h, d, g, p, f;
  if (n.emit("request:start", { request: e, requestId: t }), e.headers.get("x-msw-intention") === "bypass") {
    n.emit("request:end", { request: e, requestId: t }), (l = o == null ? void 0 : o.onPassthroughResponse) == null || l.call(o, e);
    return;
  }
  const a = await Vt(() => Xt({
    request: e,
    requestId: t,
    handlers: r,
    resolutionContext: o == null ? void 0 : o.resolutionContext
  }));
  if (a.error)
    throw n.emit("unhandledException", {
      error: a.error,
      request: e,
      requestId: t
    }), a.error;
  if (!a.data) {
    await Jt(e, s.onUnhandledRequest), n.emit("request:unhandled", { request: e, requestId: t }), n.emit("request:end", { request: e, requestId: t }), (h = o == null ? void 0 : o.onPassthroughResponse) == null || h.call(o, e);
    return;
  }
  const { response: u } = a.data;
  if (!u) {
    n.emit("request:end", { request: e, requestId: t }), (d = o == null ? void 0 : o.onPassthroughResponse) == null || d.call(o, e);
    return;
  }
  if (u.status === 302 && u.headers.get("x-msw-intention") === "passthrough") {
    n.emit("request:end", { request: e, requestId: t }), (g = o == null ? void 0 : o.onPassthroughResponse) == null || g.call(o, e);
    return;
  }
  nr(e, u), n.emit("request:match", { request: e, requestId: t });
  const i = a.data, c = ((p = o == null ? void 0 : o.transformResponse) == null ? void 0 : p.call(o, u)) || u;
  return (f = o == null ? void 0 : o.onMockedResponse) == null || f.call(
    o,
    c,
    i
  ), n.emit("request:end", { request: e, requestId: t }), c;
}
function or(e) {
  return {
    status: e.status,
    statusText: e.statusText,
    headers: Object.fromEntries(e.headers.entries())
  };
}
function Te(e) {
  return e != null && typeof e == "object" && !Array.isArray(e);
}
function et(e, t) {
  return Object.entries(t).reduce((r, [s, n]) => {
    const o = r[s];
    return Array.isArray(o) && Array.isArray(n) ? (r[s] = o.concat(n), r) : Te(o) && Te(n) ? (r[s] = et(o, n), r) : (r[s] = n, r);
  }, Object.assign({}, e));
}
var ir = class extends Error {
  constructor(t, r, s) {
    super(
      `Possible EventEmitter memory leak detected. ${s} ${r.toString()} listeners added. Use emitter.setMaxListeners() to increase limit`
    ), this.emitter = t, this.type = r, this.count = s, this.name = "MaxListenersExceededWarning";
  }
}, tt = class {
  static listenerCount(t, r) {
    return t.listenerCount(r);
  }
  constructor() {
    this.events = /* @__PURE__ */ new Map(), this.maxListeners = tt.defaultMaxListeners, this.hasWarnedAboutPotentialMemoryLeak = !1;
  }
  _emitInternalEvent(t, r, s) {
    this.emit(
      t,
      r,
      s
    );
  }
  _getListeners(t) {
    return Array.prototype.concat.apply([], this.events.get(t)) || [];
  }
  _removeListener(t, r) {
    const s = t.indexOf(r);
    return s > -1 && t.splice(s, 1), [];
  }
  _wrapOnceListener(t, r) {
    const s = (...n) => (this.removeListener(t, s), r.apply(this, n));
    return Object.defineProperty(s, "name", { value: r.name }), s;
  }
  setMaxListeners(t) {
    return this.maxListeners = t, this;
  }
  /**
   * Returns the current max listener value for the `Emitter` which is
   * either set by `emitter.setMaxListeners(n)` or defaults to
   * `Emitter.defaultMaxListeners`.
   */
  getMaxListeners() {
    return this.maxListeners;
  }
  /**
   * Returns an array listing the events for which the emitter has registered listeners.
   * The values in the array will be strings or Symbols.
   */
  eventNames() {
    return Array.from(this.events.keys());
  }
  /**
   * Synchronously calls each of the listeners registered for the event named `eventName`,
   * in the order they were registered, passing the supplied arguments to each.
   * Returns `true` if the event has listeners, `false` otherwise.
   *
   * @example
   * const emitter = new Emitter<{ hello: [string] }>()
   * emitter.emit('hello', 'John')
   */
  emit(t, ...r) {
    const s = this._getListeners(t);
    return s.forEach((n) => {
      n.apply(this, r);
    }), s.length > 0;
  }
  addListener(t, r) {
    this._emitInternalEvent("newListener", t, r);
    const s = this._getListeners(t).concat(r);
    if (this.events.set(t, s), this.maxListeners > 0 && this.listenerCount(t) > this.maxListeners && !this.hasWarnedAboutPotentialMemoryLeak) {
      this.hasWarnedAboutPotentialMemoryLeak = !0;
      const n = new ir(
        this,
        t,
        this.listenerCount(t)
      );
      console.warn(n);
    }
    return this;
  }
  on(t, r) {
    return this.addListener(t, r);
  }
  once(t, r) {
    return this.addListener(
      t,
      this._wrapOnceListener(t, r)
    );
  }
  prependListener(t, r) {
    const s = this._getListeners(t);
    if (s.length > 0) {
      const n = [r].concat(s);
      this.events.set(t, n);
    } else
      this.events.set(t, s.concat(r));
    return this;
  }
  prependOnceListener(t, r) {
    return this.prependListener(
      t,
      this._wrapOnceListener(t, r)
    );
  }
  removeListener(t, r) {
    const s = this._getListeners(t);
    return s.length > 0 && (this._removeListener(s, r), this.events.set(t, s), this._emitInternalEvent("removeListener", t, r)), this;
  }
  /**
   * Alias for `emitter.removeListener()`.
   *
   * @example
   * emitter.off('hello', listener)
   */
  off(t, r) {
    return this.removeListener(t, r);
  }
  removeAllListeners(t) {
    return t ? this.events.delete(t) : this.events.clear(), this;
  }
  /**
   * Returns a copy of the array of listeners for the event named `eventName`.
   */
  listeners(t) {
    return Array.from(this._getListeners(t));
  }
  /**
   * Returns the number of listeners listening to the event named `eventName`.
   */
  listenerCount(t) {
    return this._getListeners(t).length;
  }
  rawListeners(t) {
    return this.listeners(t);
  }
}, ue = tt;
ue.defaultMaxListeners = 10;
function ar(e, t) {
  const r = e.emit;
  if (r._isPiped)
    return;
  const s = function(o, ...a) {
    return t.emit(o, ...a), r.call(this, o, ...a);
  };
  s._isPiped = !0, e.emit = s;
}
function cr(e) {
  const t = [...e];
  return Object.freeze(t), t;
}
class lr {
  constructor() {
    E(this, "subscriptions", []);
  }
  async dispose() {
    await Promise.all(this.subscriptions.map((t) => t()));
  }
}
class ur {
  constructor(t) {
    E(this, "handlers");
    this.initialHandlers = t, this.handlers = [...t];
  }
  prepend(t) {
    this.handlers.unshift(...t);
  }
  reset(t) {
    this.handlers = t.length > 0 ? [...t] : [...this.initialHandlers];
  }
  currentHandlers() {
    return this.handlers;
  }
}
class dr extends lr {
  constructor(...r) {
    super();
    E(this, "handlersController");
    E(this, "emitter");
    E(this, "publicEmitter");
    E(this, "events");
    X(
      this.validateHandlers(r),
      k.formatMessage(
        "Failed to apply given request handlers: invalid input. Did you forget to spread the request handlers Array?"
      )
    ), this.handlersController = new ur(r), this.emitter = new ue(), this.publicEmitter = new ue(), ar(this.emitter, this.publicEmitter), this.events = this.createLifeCycleEvents(), this.subscriptions.push(() => {
      this.emitter.removeAllListeners(), this.publicEmitter.removeAllListeners();
    });
  }
  validateHandlers(r) {
    return r.every((s) => !Array.isArray(s));
  }
  use(...r) {
    X(
      this.validateHandlers(r),
      k.formatMessage(
        'Failed to call "use()" with the given request handlers: invalid input. Did you forget to spread the array of request handlers?'
      )
    ), this.handlersController.prepend(r);
  }
  restoreHandlers() {
    this.handlersController.currentHandlers().forEach((r) => {
      r.isUsed = !1;
    });
  }
  resetHandlers(...r) {
    this.handlersController.reset(r);
  }
  listHandlers() {
    return cr(this.handlersController.currentHandlers());
  }
  createLifeCycleEvents() {
    return {
      on: (...r) => this.publicEmitter.on(...r),
      removeListener: (...r) => this.publicEmitter.removeListener(...r),
      removeAllListeners: (...r) => this.publicEmitter.removeAllListeners(...r)
    };
  }
}
var hr = /(%?)(%([sdijo]))/g;
function fr(e, t) {
  switch (t) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const r = JSON.stringify(e);
      return r === "{}" || r === "[]" || /^\[object .+?\]$/.test(r) ? e : r;
    }
  }
}
function J(e, ...t) {
  if (t.length === 0)
    return e;
  let r = 0, s = e.replace(
    hr,
    (n, o, a, u) => {
      const i = t[r], c = fr(i, u);
      return o ? n : (r++, c);
    }
  );
  return r < t.length && (s += ` ${t.slice(r).join(" ")}`), s = s.replace(/%{2,2}/g, "%"), s;
}
var pr = 2;
function gr(e) {
  if (!e.stack)
    return;
  const t = e.stack.split(`
`);
  t.splice(1, pr), e.stack = t.join(`
`);
}
var mr = class extends Error {
  constructor(e, ...t) {
    super(e), this.message = e, this.name = "Invariant Violation", this.message = J(e, ...t), gr(this);
  }
}, O = (e, t, ...r) => {
  if (!e)
    throw new mr(t, ...r);
};
O.as = (e, t, r, ...s) => {
  if (!t) {
    const n = s.length === 0 ? r : J(r, s);
    let o;
    try {
      o = Reflect.construct(e, [n]);
    } catch {
      o = e(n);
    }
    throw o;
  }
};
function we() {
  if (typeof navigator < "u" && navigator.product === "ReactNative")
    return !0;
  if (typeof process < "u") {
    const e = process.type;
    return e === "renderer" || e === "worker" ? !1 : !!(process.versions && process.versions.node);
  }
  return !1;
}
var be = async (e) => {
  try {
    return { error: null, data: await e().catch((r) => {
      throw r;
    }) };
  } catch (t) {
    return { error: t, data: null };
  }
};
function vr(e) {
  return new URL(e, location.href).href;
}
function oe(e, t, r) {
  return [
    e.active,
    e.installing,
    e.waiting
  ].filter((a) => a != null).find((a) => r(a.scriptURL, t)) || null;
}
var yr = async (e, t = {}, r) => {
  const s = vr(e), n = await navigator.serviceWorker.getRegistrations().then(
    (u) => u.filter(
      (i) => oe(i, s, r)
    )
  );
  !navigator.serviceWorker.controller && n.length > 0 && location.reload();
  const [o] = n;
  if (o)
    return o.update().then(() => [
      oe(
        o,
        s,
        r
      ),
      o
    ]);
  const a = await be(
    async () => {
      const u = await navigator.serviceWorker.register(e, t);
      return [
        // Compare existing worker registration by its worker URL,
        // to prevent irrelevant workers to resolve here (such as Codesandbox worker).
        oe(u, s, r),
        u
      ];
    }
  );
  if (a.error) {
    if (a.error.message.includes("(404)")) {
      const i = new URL((t == null ? void 0 : t.scope) || "/", location.href);
      throw new Error(
        k.formatMessage(`Failed to register a Service Worker for scope ('${i.href}') with script ('${s}'): Service Worker script does not exist at the given path.

Did you forget to run "npx msw init <PUBLIC_DIR>"?

Learn more about creating the Service Worker script: https://mswjs.io/docs/cli/init`)
      );
    }
    throw new Error(
      k.formatMessage(
        `Failed to register the Service Worker:

%s`,
        a.error.message
      )
    );
  }
  return a.data;
};
function rt(e = {}) {
  if (e.quiet)
    return;
  const t = e.message || "Mocking enabled.";
  console.groupCollapsed(
    `%c${k.formatMessage(t)}`,
    "color:orangered;font-weight:bold;"
  ), console.log(
    "%cDocumentation: %chttps://mswjs.io/docs",
    "font-weight:bold",
    "font-weight:normal"
  ), console.log("Found an issue? https://github.com/mswjs/msw/issues"), e.workerUrl && console.log("Worker script URL:", e.workerUrl), e.workerScope && console.log("Worker scope:", e.workerScope), console.groupEnd();
}
async function wr(e, t) {
  var r, s;
  if (e.workerChannel.send("MOCK_ACTIVATE"), await e.events.once("MOCKING_ENABLED"), e.isMockingEnabled) {
    k.warn(
      'Found a redundant "worker.start()" call. Note that starting the worker while mocking is already enabled will have no effect. Consider removing this "worker.start()" call.'
    );
    return;
  }
  e.isMockingEnabled = !0, rt({
    quiet: t.quiet,
    workerScope: (r = e.registration) == null ? void 0 : r.scope,
    workerUrl: (s = e.worker) == null ? void 0 : s.scriptURL
  });
}
var br = class {
  constructor(e) {
    this.port = e;
  }
  postMessage(e, ...t) {
    const [r, s] = t;
    this.port.postMessage({ type: e, data: r }, { transfer: s });
  }
};
function Er(e) {
  if (!["HEAD", "GET"].includes(e.method))
    return e.body;
}
function kr(e) {
  return new Request(e.url, {
    ...e,
    body: Er(e)
  });
}
var xr = (e, t) => async (r, s) => {
  const n = new br(r.ports[0]), o = s.payload.id, a = kr(s.payload), u = a.clone(), i = a.clone();
  Z.cache.set(a, i), e.requests.set(o, i);
  try {
    await Qe(
      a,
      o,
      e.getRequestHandlers(),
      t,
      e.emitter,
      {
        onPassthroughResponse() {
          n.postMessage("NOT_FOUND");
        },
        async onMockedResponse(c, { handler: l, parsedResult: h }) {
          const d = c.clone(), g = c.clone(), p = or(c);
          if (e.supports.readableStreamTransfer) {
            const f = c.body;
            n.postMessage(
              "MOCK_RESPONSE",
              {
                ...p,
                body: f
              },
              f ? [f] : void 0
            );
          } else {
            const f = c.body === null ? null : await d.arrayBuffer();
            n.postMessage("MOCK_RESPONSE", {
              ...p,
              body: f
            });
          }
          t.quiet || e.emitter.once("response:mocked", () => {
            l.log({
              request: u,
              response: g,
              parsedResult: h
            });
          });
        }
      }
    );
  } catch (c) {
    c instanceof Error && (k.error(
      `Uncaught exception in the request handler for "%s %s":

%s

This exception has been gracefully handled as a 500 response, however, it's strongly recommended to resolve this error, as it indicates a mistake in your code. If you wish to mock an error response, please see this guide: https://mswjs.io/docs/recipes/mocking-error-responses`,
      a.method,
      a.url,
      c.stack ?? c
    ), n.postMessage("MOCK_RESPONSE", {
      status: 500,
      statusText: "Request Handler Error",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: c.name,
        message: c.message,
        stack: c.stack
      })
    }));
  }
};
async function Rr(e) {
  e.workerChannel.send("INTEGRITY_CHECK_REQUEST");
  const { payload: t } = await e.events.once("INTEGRITY_CHECK_RESPONSE");
  t.checksum !== "5db7e6e8385dc04e017ac4823e0e9b29" && k.warn(
    `The currently registered Service Worker has been generated by a different version of MSW (${t.packageVersion}) and may not be fully compatible with the installed version.

It's recommended you update your worker script by running this command:

  • npx msw init <PUBLIC_DIR>

You can also automate this process and make the worker script update automatically upon the library installations. Read more: https://mswjs.io/docs/cli/init.`
  );
}
var Sr = new TextEncoder();
function _r(e) {
  return Sr.encode(e);
}
function Lr(e, t) {
  return new TextDecoder(t).decode(e);
}
function Tr(e) {
  return e.buffer.slice(
    e.byteOffset,
    e.byteOffset + e.byteLength
  );
}
var Cr = /* @__PURE__ */ new Set([
  101,
  103,
  204,
  205,
  304
]);
function st(e) {
  return Cr.has(e);
}
var Pr = Object.defineProperty, Ar = (e, t) => {
  for (var r in t)
    Pr(e, r, { get: t[r], enumerable: !0 });
}, de = {};
Ar(de, {
  blue: () => Mr,
  gray: () => he,
  green: () => qr,
  red: () => Or,
  yellow: () => Ir
});
function Ir(e) {
  return `\x1B[33m${e}\x1B[0m`;
}
function Mr(e) {
  return `\x1B[34m${e}\x1B[0m`;
}
function he(e) {
  return `\x1B[90m${e}\x1B[0m`;
}
function Or(e) {
  return `\x1B[31m${e}\x1B[0m`;
}
function qr(e) {
  return `\x1B[32m${e}\x1B[0m`;
}
var Q = we(), nt = class {
  constructor(e) {
    E(this, "prefix");
    this.name = e, this.prefix = `[${this.name}]`;
    const t = Ce("DEBUG"), r = Ce("LOG_LEVEL");
    t === "1" || t === "true" || typeof t < "u" && this.name.startsWith(t) ? (this.debug = W(r, "debug") ? L : this.debug, this.info = W(r, "info") ? L : this.info, this.success = W(r, "success") ? L : this.success, this.warning = W(r, "warning") ? L : this.warning, this.error = W(r, "error") ? L : this.error) : (this.info = L, this.success = L, this.warning = L, this.error = L, this.only = L);
  }
  extend(e) {
    return new nt(`${this.name}:${e}`);
  }
  /**
   * Print a debug message.
   * @example
   * logger.debug('no duplicates found, creating a document...')
   */
  debug(e, ...t) {
    this.logEntry({
      level: "debug",
      message: he(e),
      positionals: t,
      prefix: this.prefix,
      colors: {
        prefix: "gray"
      }
    });
  }
  /**
   * Print an info message.
   * @example
   * logger.info('start parsing...')
   */
  info(e, ...t) {
    this.logEntry({
      level: "info",
      message: e,
      positionals: t,
      prefix: this.prefix,
      colors: {
        prefix: "blue"
      }
    });
    const r = new jr();
    return (s, ...n) => {
      r.measure(), this.logEntry({
        level: "info",
        message: `${s} ${he(`${r.deltaTime}ms`)}`,
        positionals: n,
        prefix: this.prefix,
        colors: {
          prefix: "blue"
        }
      });
    };
  }
  /**
   * Print a success message.
   * @example
   * logger.success('successfully created document')
   */
  success(e, ...t) {
    this.logEntry({
      level: "info",
      message: e,
      positionals: t,
      prefix: `✔ ${this.prefix}`,
      colors: {
        timestamp: "green",
        prefix: "green"
      }
    });
  }
  /**
   * Print a warning.
   * @example
   * logger.warning('found legacy document format')
   */
  warning(e, ...t) {
    this.logEntry({
      level: "warning",
      message: e,
      positionals: t,
      prefix: `⚠ ${this.prefix}`,
      colors: {
        timestamp: "yellow",
        prefix: "yellow"
      }
    });
  }
  /**
   * Print an error message.
   * @example
   * logger.error('something went wrong')
   */
  error(e, ...t) {
    this.logEntry({
      level: "error",
      message: e,
      positionals: t,
      prefix: `✖ ${this.prefix}`,
      colors: {
        timestamp: "red",
        prefix: "red"
      }
    });
  }
  /**
   * Execute the given callback only when the logging is enabled.
   * This is skipped in its entirety and has no runtime cost otherwise.
   * This executes regardless of the log level.
   * @example
   * logger.only(() => {
   *   logger.info('additional info')
   * })
   */
  only(e) {
    e();
  }
  createEntry(e, t) {
    return {
      timestamp: /* @__PURE__ */ new Date(),
      level: e,
      message: t
    };
  }
  logEntry(e) {
    const {
      level: t,
      message: r,
      prefix: s,
      colors: n,
      positionals: o = []
    } = e, a = this.createEntry(t, r), u = (n == null ? void 0 : n.timestamp) || "gray", i = (n == null ? void 0 : n.prefix) || "gray", c = {
      timestamp: de[u],
      prefix: de[i]
    };
    this.getWriter(t)(
      [c.timestamp(this.formatTimestamp(a.timestamp))].concat(s != null ? c.prefix(s) : []).concat(Pe(r)).join(" "),
      ...o.map(Pe)
    );
  }
  formatTimestamp(e) {
    return `${e.toLocaleTimeString(
      "en-GB"
    )}:${e.getMilliseconds()}`;
  }
  getWriter(e) {
    switch (e) {
      case "debug":
      case "success":
      case "info":
        return Nr;
      case "warning":
        return $r;
      case "error":
        return Dr;
    }
  }
}, jr = class {
  constructor() {
    E(this, "startTime");
    E(this, "endTime");
    E(this, "deltaTime");
    this.startTime = performance.now();
  }
  measure() {
    this.endTime = performance.now();
    const e = this.endTime - this.startTime;
    this.deltaTime = e.toFixed(2);
  }
}, L = () => {
};
function Nr(e, ...t) {
  if (Q) {
    process.stdout.write(J(e, ...t) + `
`);
    return;
  }
  console.log(e, ...t);
}
function $r(e, ...t) {
  if (Q) {
    process.stderr.write(J(e, ...t) + `
`);
    return;
  }
  console.warn(e, ...t);
}
function Dr(e, ...t) {
  if (Q) {
    process.stderr.write(J(e, ...t) + `
`);
    return;
  }
  console.error(e, ...t);
}
function Ce(e) {
  var t;
  return Q ? process.env[e] : (t = globalThis[e]) == null ? void 0 : t.toString();
}
function W(e, t) {
  return e !== void 0 && e !== t;
}
function Pe(e) {
  return typeof e > "u" ? "undefined" : e === null ? "null" : typeof e == "string" ? e : typeof e == "object" ? JSON.stringify(e) : e.toString();
}
var Ur = class extends Error {
  constructor(e, t, r) {
    super(
      `Possible EventEmitter memory leak detected. ${r} ${t.toString()} listeners added. Use emitter.setMaxListeners() to increase limit`
    ), this.emitter = e, this.type = t, this.count = r, this.name = "MaxListenersExceededWarning";
  }
}, ot = class {
  static listenerCount(e, t) {
    return e.listenerCount(t);
  }
  constructor() {
    this.events = /* @__PURE__ */ new Map(), this.maxListeners = ot.defaultMaxListeners, this.hasWarnedAboutPotentialMemoryLeak = !1;
  }
  _emitInternalEvent(e, t, r) {
    this.emit(
      e,
      t,
      r
    );
  }
  _getListeners(e) {
    return Array.prototype.concat.apply([], this.events.get(e)) || [];
  }
  _removeListener(e, t) {
    const r = e.indexOf(t);
    return r > -1 && e.splice(r, 1), [];
  }
  _wrapOnceListener(e, t) {
    const r = (...s) => (this.removeListener(e, r), t.apply(this, s));
    return Object.defineProperty(r, "name", { value: t.name }), r;
  }
  setMaxListeners(e) {
    return this.maxListeners = e, this;
  }
  /**
   * Returns the current max listener value for the `Emitter` which is
   * either set by `emitter.setMaxListeners(n)` or defaults to
   * `Emitter.defaultMaxListeners`.
   */
  getMaxListeners() {
    return this.maxListeners;
  }
  /**
   * Returns an array listing the events for which the emitter has registered listeners.
   * The values in the array will be strings or Symbols.
   */
  eventNames() {
    return Array.from(this.events.keys());
  }
  /**
   * Synchronously calls each of the listeners registered for the event named `eventName`,
   * in the order they were registered, passing the supplied arguments to each.
   * Returns `true` if the event has listeners, `false` otherwise.
   *
   * @example
   * const emitter = new Emitter<{ hello: [string] }>()
   * emitter.emit('hello', 'John')
   */
  emit(e, ...t) {
    const r = this._getListeners(e);
    return r.forEach((s) => {
      s.apply(this, t);
    }), r.length > 0;
  }
  addListener(e, t) {
    this._emitInternalEvent("newListener", e, t);
    const r = this._getListeners(e).concat(t);
    if (this.events.set(e, r), this.maxListeners > 0 && this.listenerCount(e) > this.maxListeners && !this.hasWarnedAboutPotentialMemoryLeak) {
      this.hasWarnedAboutPotentialMemoryLeak = !0;
      const s = new Ur(
        this,
        e,
        this.listenerCount(e)
      );
      console.warn(s);
    }
    return this;
  }
  on(e, t) {
    return this.addListener(e, t);
  }
  once(e, t) {
    return this.addListener(
      e,
      this._wrapOnceListener(e, t)
    );
  }
  prependListener(e, t) {
    const r = this._getListeners(e);
    if (r.length > 0) {
      const s = [t].concat(r);
      this.events.set(e, s);
    } else
      this.events.set(e, r.concat(t));
    return this;
  }
  prependOnceListener(e, t) {
    return this.prependListener(
      e,
      this._wrapOnceListener(e, t)
    );
  }
  removeListener(e, t) {
    const r = this._getListeners(e);
    return r.length > 0 && (this._removeListener(r, t), this.events.set(e, r), this._emitInternalEvent("removeListener", e, t)), this;
  }
  /**
   * Alias for `emitter.removeListener()`.
   *
   * @example
   * emitter.off('hello', listener)
   */
  off(e, t) {
    return this.removeListener(e, t);
  }
  removeAllListeners(e) {
    return e ? this.events.delete(e) : this.events.clear(), this;
  }
  /**
   * Returns a copy of the array of listeners for the event named `eventName`.
   */
  listeners(e) {
    return Array.from(this._getListeners(e));
  }
  /**
   * Returns the number of listeners listening to the event named `eventName`.
   */
  listenerCount(e) {
    return this._getListeners(e).length;
  }
  rawListeners(e) {
    return this.listeners(e);
  }
}, it = ot;
it.defaultMaxListeners = 10;
var U = Symbol("isPatchedModule");
function Ae(e) {
  return (
    // @ts-ignore https://github.com/Microsoft/TypeScript/issues/24587
    globalThis[e] || void 0
  );
}
function Hr(e, t) {
  globalThis[e] = t;
}
function Br(e) {
  delete globalThis[e];
}
var Ee = class {
  constructor(e) {
    this.symbol = e, this.readyState = "INACTIVE", this.emitter = new it(), this.subscriptions = [], this.logger = new nt(e.description), this.emitter.setMaxListeners(0), this.logger.info("constructing the interceptor...");
  }
  /**
   * Determine if this interceptor can be applied
   * in the current environment.
   */
  checkEnvironment() {
    return !0;
  }
  /**
   * Apply this interceptor to the current process.
   * Returns an already running interceptor instance if it's present.
   */
  apply() {
    const e = this.logger.extend("apply");
    if (e.info("applying the interceptor..."), this.readyState === "APPLIED") {
      e.info("intercepted already applied!");
      return;
    }
    if (!this.checkEnvironment()) {
      e.info("the interceptor cannot be applied in this environment!");
      return;
    }
    this.readyState = "APPLYING";
    const r = this.getInstance();
    if (r) {
      e.info("found a running instance, reusing..."), this.on = (s, n) => (e.info('proxying the "%s" listener', s), r.emitter.addListener(s, n), this.subscriptions.push(() => {
        r.emitter.removeListener(s, n), e.info('removed proxied "%s" listener!', s);
      }), this), this.readyState = "APPLIED";
      return;
    }
    e.info("no running instance found, setting up a new instance..."), this.setup(), this.setInstance(), this.readyState = "APPLIED";
  }
  /**
   * Setup the module augments and stubs necessary for this interceptor.
   * This method is not run if there's a running interceptor instance
   * to prevent instantiating an interceptor multiple times.
   */
  setup() {
  }
  /**
   * Listen to the interceptor's public events.
   */
  on(e, t) {
    const r = this.logger.extend("on");
    return this.readyState === "DISPOSING" || this.readyState === "DISPOSED" ? (r.info("cannot listen to events, already disposed!"), this) : (r.info('adding "%s" event listener:', e, t), this.emitter.on(e, t), this);
  }
  once(e, t) {
    return this.emitter.once(e, t), this;
  }
  off(e, t) {
    return this.emitter.off(e, t), this;
  }
  removeAllListeners(e) {
    return this.emitter.removeAllListeners(e), this;
  }
  /**
   * Disposes of any side-effects this interceptor has introduced.
   */
  dispose() {
    const e = this.logger.extend("dispose");
    if (this.readyState === "DISPOSED") {
      e.info("cannot dispose, already disposed!");
      return;
    }
    if (e.info("disposing the interceptor..."), this.readyState = "DISPOSING", !this.getInstance()) {
      e.info("no interceptors running, skipping dispose...");
      return;
    }
    if (this.clearInstance(), e.info("global symbol deleted:", Ae(this.symbol)), this.subscriptions.length > 0) {
      e.info("disposing of %d subscriptions...", this.subscriptions.length);
      for (const t of this.subscriptions)
        t();
      this.subscriptions = [], e.info("disposed of all subscriptions!", this.subscriptions.length);
    }
    this.emitter.removeAllListeners(), e.info("destroyed the listener!"), this.readyState = "DISPOSED";
  }
  getInstance() {
    var e;
    const t = Ae(this.symbol);
    return this.logger.info("retrieved global instance:", (e = t == null ? void 0 : t.constructor) == null ? void 0 : e.name), t;
  }
  setInstance() {
    Hr(this.symbol, this), this.logger.info("set global instance!", this.symbol.description);
  }
  clearInstance() {
    Br(this.symbol), this.logger.info("cleared global instance!", this.symbol.description);
  }
}, fe = class extends Ee {
  constructor(e) {
    fe.symbol = Symbol(e.name), super(fe.symbol), this.interceptors = e.interceptors;
  }
  setup() {
    const e = this.logger.extend("setup");
    e.info("applying all %d interceptors...", this.interceptors.length);
    for (const t of this.interceptors)
      e.info('applying "%s" interceptor...', t.constructor.name), t.apply(), e.info("adding interceptor dispose subscription"), this.subscriptions.push(() => t.dispose());
  }
  on(e, t) {
    for (const r of this.interceptors)
      r.on(e, t);
    return this;
  }
  once(e, t) {
    for (const r of this.interceptors)
      r.once(e, t);
    return this;
  }
  off(e, t) {
    for (const r of this.interceptors)
      r.off(e, t);
    return this;
  }
  removeAllListeners(e) {
    for (const t of this.interceptors)
      t.removeAllListeners(e);
    return this;
  }
};
function Wr(e) {
  return (t, r) => {
    var u;
    const { payload: s } = r, { requestId: n } = s, o = e.requests.get(n);
    if (e.requests.delete(n), (u = s.type) != null && u.includes("opaque"))
      return;
    const a = s.status === 0 ? Response.error() : new Response(
      /**
       * Responses may be streams here, but when we create a response object
       * with null-body status codes, like 204, 205, 304 Response will
       * throw when passed a non-null body, so ensure it's null here
       * for those codes
       */
      st(s.status) ? null : s.body,
      s
    );
    a.url || Object.defineProperty(a, "url", {
      value: o.url,
      enumerable: !0,
      writable: !1
    }), e.emitter.emit(
      s.isMockedResponse ? "response:mocked" : "response:bypass",
      {
        response: a,
        request: o,
        requestId: s.requestId
      }
    );
  };
}
function Fr(e, t) {
  !(t != null && t.quiet) && !location.href.startsWith(e.scope) && k.warn(
    `Cannot intercept requests on this page because it's outside of the worker's scope ("${e.scope}"). If you wish to mock API requests on this page, you must resolve this scope issue.

- (Recommended) Register the worker at the root level ("/") of your application.
- Set the "Service-Worker-Allowed" response header to allow out-of-scope workers.`
  );
}
var Gr = (e) => function(r, s) {
  return (async () => {
    e.events.removeAllListeners(), e.workerChannel.on(
      "REQUEST",
      xr(e, r)
    ), e.workerChannel.on("RESPONSE", Wr(e));
    const a = await yr(
      r.serviceWorker.url,
      r.serviceWorker.options,
      r.findWorker
    ), [u, i] = a;
    if (!u) {
      const c = s != null && s.findWorker ? k.formatMessage(
        `Failed to locate the Service Worker registration using a custom "findWorker" predicate.

Please ensure that the custom predicate properly locates the Service Worker registration at "%s".
More details: https://mswjs.io/docs/api/setup-worker/start#findworker
`,
        r.serviceWorker.url
      ) : k.formatMessage(
        `Failed to locate the Service Worker registration.

This most likely means that the worker script URL "%s" cannot resolve against the actual public hostname (%s). This may happen if your application runs behind a proxy, or has a dynamic hostname.

Please consider using a custom "serviceWorker.url" option to point to the actual worker script location, or a custom "findWorker" option to resolve the Service Worker registration manually. More details: https://mswjs.io/docs/api/setup-worker/start`,
        r.serviceWorker.url,
        location.host
      );
      throw new Error(c);
    }
    return e.worker = u, e.registration = i, e.events.addListener(window, "beforeunload", () => {
      u.state !== "redundant" && e.workerChannel.send("CLIENT_CLOSED"), window.clearInterval(e.keepAliveInterval);
    }), await Rr(e).catch((c) => {
      k.error(
        "Error while checking the worker script integrity. Please report this on GitHub (https://github.com/mswjs/msw/issues), including the original error below."
      ), console.error(c);
    }), e.keepAliveInterval = window.setInterval(
      () => e.workerChannel.send("KEEPALIVE_REQUEST"),
      5e3
    ), Fr(i, e.startOptions), i;
  })().then(
    async (a) => {
      const u = a.installing || a.waiting;
      return u && await new Promise((i) => {
        u.addEventListener("statechange", () => {
          if (u.state === "activated")
            return i();
        });
      }), await wr(e, r).catch((i) => {
        throw new Error(`Failed to enable mocking: ${i == null ? void 0 : i.message}`);
      }), a;
    }
  );
};
function at(e = {}) {
  e.quiet || console.log(
    `%c${k.formatMessage("Mocking disabled.")}`,
    "color:orangered;font-weight:bold;"
  );
}
var Vr = (e) => function() {
  var r;
  if (!e.isMockingEnabled) {
    k.warn(
      'Found a redundant "worker.stop()" call. Note that stopping the worker while mocking already stopped has no effect. Consider removing this "worker.stop()" call.'
    );
    return;
  }
  e.workerChannel.send("MOCK_DEACTIVATE"), e.isMockingEnabled = !1, window.clearInterval(e.keepAliveInterval), at({ quiet: (r = e.startOptions) == null ? void 0 : r.quiet });
}, Xr = {
  serviceWorker: {
    url: "/mockServiceWorker.js",
    options: null
  },
  quiet: !1,
  waitUntilReady: !0,
  onUnhandledRequest: "warn",
  findWorker(e, t) {
    return e === t;
  }
};
function Jr() {
  const e = (t, r) => {
    e.state = "pending", e.resolve = (s) => {
      if (e.state !== "pending")
        return;
      e.result = s;
      const n = (o) => (e.state = "fulfilled", o);
      return t(
        s instanceof Promise ? s : Promise.resolve(s).then(n)
      );
    }, e.reject = (s) => {
      if (e.state === "pending")
        return queueMicrotask(() => {
          e.state = "rejected";
        }), r(e.rejectionReason = s);
    };
  };
  return e;
}
var P, H, Y, Je, ct = (Je = class extends Promise {
  constructor(t = null) {
    const r = Jr();
    super((s, n) => {
      r(s, n), t == null || t(r.resolve, r.reject);
    });
    ne(this, H);
    ne(this, P, void 0);
    E(this, "resolve");
    E(this, "reject");
    xe(this, P, r), this.resolve = B(this, P).resolve, this.reject = B(this, P).reject;
  }
  get state() {
    return B(this, P).state;
  }
  get rejectionReason() {
    return B(this, P).rejectionReason;
  }
  then(t, r) {
    return z(this, H, Y).call(this, super.then(t, r));
  }
  catch(t) {
    return z(this, H, Y).call(this, super.catch(t));
  }
  finally(t) {
    return z(this, H, Y).call(this, super.finally(t));
  }
}, P = new WeakMap(), H = new WeakSet(), Y = function(t) {
  return Object.defineProperties(t, {
    resolve: { configurable: !0, value: this.resolve },
    reject: { configurable: !0, value: this.reject }
  });
}, Je);
function lt() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const t = Math.random() * 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}
var zr = class {
  constructor(e) {
    this.request = e, this.responsePromise = new ct();
  }
  respondWith(e) {
    O(
      this.responsePromise.state === "pending",
      'Failed to respond to "%s %s" request: the "request" event has already been responded to.',
      this.request.method,
      this.request.url
    ), this.responsePromise.resolve(e);
  }
};
function ut(e) {
  const t = new zr(e);
  return Reflect.set(
    e,
    "respondWith",
    t.respondWith.bind(t)
  ), {
    interactiveRequest: e,
    requestController: t
  };
}
async function dt(e, t, ...r) {
  const s = e.listeners(t);
  if (s.length !== 0)
    for (const n of s)
      await n.apply(e, r);
}
function Yr(e, t) {
  try {
    return e[t], !0;
  } catch {
    return !1;
  }
}
function Zr(e) {
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}
var ht = class extends Ee {
  constructor() {
    super(ht.symbol);
  }
  checkEnvironment() {
    return typeof globalThis < "u" && typeof globalThis.fetch < "u";
  }
  setup() {
    const e = globalThis.fetch;
    O(
      !e[U],
      'Failed to patch the "fetch" module: already patched.'
    ), globalThis.fetch = async (t, r) => {
      var s;
      const n = lt(), o = typeof t == "string" && typeof location < "u" && !Zr(t) ? new URL(t, location.origin) : t, a = new Request(o, r);
      this.logger.info("[%s] %s", a.method, a.url);
      const { interactiveRequest: u, requestController: i } = ut(a);
      this.logger.info(
        'emitting the "request" event for %d listener(s)...',
        this.emitter.listenerCount("request")
      ), this.emitter.once("request", ({ requestId: g }) => {
        g === n && i.responsePromise.state === "pending" && i.responsePromise.resolve(void 0);
      }), this.logger.info("awaiting for the mocked response...");
      const c = u.signal, l = new ct();
      c && c.addEventListener(
        "abort",
        () => {
          l.reject(c.reason);
        },
        { once: !0 }
      );
      const h = await be(async () => {
        const g = dt(this.emitter, "request", {
          request: u,
          requestId: n
        });
        await Promise.race([
          l,
          // Put the listeners invocation Promise in the same race condition
          // with the request abort Promise because otherwise awaiting the listeners
          // would always yield some response (or undefined).
          g,
          i.responsePromise
        ]), this.logger.info("all request listeners have been resolved!");
        const p = await i.responsePromise;
        return this.logger.info("event.respondWith called with:", p), p;
      });
      if (l.state === "rejected")
        return Promise.reject(l.rejectionReason);
      if (h.error)
        return Promise.reject(Ie(h.error));
      const d = h.data;
      if (d && !((s = a.signal) != null && s.aborted)) {
        if (this.logger.info("received mocked response:", d), Yr(d, "type") && d.type === "error")
          return this.logger.info(
            "received a network error response, rejecting the request promise..."
          ), Promise.reject(Ie(d));
        const g = d.clone();
        return this.emitter.emit("response", {
          response: g,
          isMockedResponse: !0,
          request: u,
          requestId: n
        }), Object.defineProperty(d, "url", {
          writable: !1,
          enumerable: !0,
          configurable: !1,
          value: a.url
        }), d;
      }
      return this.logger.info("no mocked response received!"), e(a).then((g) => {
        const p = g.clone();
        return this.logger.info("original fetch performed", p), this.emitter.emit("response", {
          response: p,
          isMockedResponse: !1,
          request: u,
          requestId: n
        }), g;
      });
    }, Object.defineProperty(globalThis.fetch, U, {
      enumerable: !0,
      configurable: !0,
      value: !0
    }), this.subscriptions.push(() => {
      Object.defineProperty(globalThis.fetch, U, {
        value: void 0
      }), globalThis.fetch = e, this.logger.info(
        'restored native "globalThis.fetch"!',
        globalThis.fetch.name
      );
    });
  }
}, ft = ht;
ft.symbol = Symbol("fetch");
function Ie(e) {
  return Object.assign(new TypeError("Failed to fetch"), {
    cause: e
  });
}
function Kr(e, t) {
  const r = new Uint8Array(e.byteLength + t.byteLength);
  return r.set(e, 0), r.set(t, e.byteLength), r;
}
var pt = class {
  constructor(e, t) {
    this.AT_TARGET = 0, this.BUBBLING_PHASE = 0, this.CAPTURING_PHASE = 0, this.NONE = 0, this.type = "", this.srcElement = null, this.currentTarget = null, this.eventPhase = 0, this.isTrusted = !0, this.composed = !1, this.cancelable = !0, this.defaultPrevented = !1, this.bubbles = !0, this.lengthComputable = !0, this.loaded = 0, this.total = 0, this.cancelBubble = !1, this.returnValue = !0, this.type = e, this.target = (t == null ? void 0 : t.target) || null, this.currentTarget = (t == null ? void 0 : t.currentTarget) || null, this.timeStamp = Date.now();
  }
  composedPath() {
    return [];
  }
  initEvent(e, t, r) {
    this.type = e, this.bubbles = !!t, this.cancelable = !!r;
  }
  preventDefault() {
    this.defaultPrevented = !0;
  }
  stopPropagation() {
  }
  stopImmediatePropagation() {
  }
}, Qr = class extends pt {
  constructor(e, t) {
    super(e), this.lengthComputable = (t == null ? void 0 : t.lengthComputable) || !1, this.composed = (t == null ? void 0 : t.composed) || !1, this.loaded = (t == null ? void 0 : t.loaded) || 0, this.total = (t == null ? void 0 : t.total) || 0;
  }
}, es = typeof ProgressEvent < "u";
function ts(e, t, r) {
  const s = [
    "error",
    "progress",
    "loadstart",
    "loadend",
    "load",
    "timeout",
    "abort"
  ], n = es ? ProgressEvent : Qr;
  return s.includes(t) ? new n(t, {
    lengthComputable: !0,
    loaded: (r == null ? void 0 : r.loaded) || 0,
    total: (r == null ? void 0 : r.total) || 0
  }) : new pt(t, {
    target: e,
    currentTarget: e
  });
}
function gt(e, t) {
  if (!(t in e))
    return null;
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e;
  const s = Reflect.getPrototypeOf(e);
  return s ? gt(s, t) : null;
}
function Me(e, t) {
  return new Proxy(e, rs(t));
}
function rs(e) {
  const { constructorCall: t, methodCall: r, getProperty: s, setProperty: n } = e, o = {};
  return typeof t < "u" && (o.construct = function(a, u, i) {
    const c = Reflect.construct.bind(null, a, u, i);
    return t.call(i, u, c);
  }), o.set = function(a, u, i) {
    const c = () => {
      const l = gt(a, u) || a, h = Reflect.getOwnPropertyDescriptor(
        l,
        u
      );
      return typeof (h == null ? void 0 : h.set) < "u" ? (h.set.apply(a, [i]), !0) : Reflect.defineProperty(l, u, {
        writable: !0,
        enumerable: !0,
        configurable: !0,
        value: i
      });
    };
    return typeof n < "u" ? n.call(a, [u, i], c) : c();
  }, o.get = function(a, u, i) {
    const c = () => a[u], l = typeof s < "u" ? s.call(a, [u, i], c) : c();
    return typeof l == "function" ? (...h) => {
      const d = l.bind(a, ...h);
      return typeof r < "u" ? r.call(a, [u, h], d) : d();
    } : l;
  }, o;
}
function ss(e) {
  return [
    "application/xhtml+xml",
    "application/xml",
    "image/svg+xml",
    "text/html",
    "text/xml"
  ].some((r) => e.startsWith(r));
}
function ns(e) {
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
function os(e, t) {
  const r = st(e.status) ? null : t;
  return new Response(r, {
    status: e.status,
    statusText: e.statusText,
    headers: is(
      e.getAllResponseHeaders()
    )
  });
}
function is(e) {
  const t = new Headers(), r = e.split(/[\r\n]+/);
  for (const s of r) {
    if (s.trim() === "")
      continue;
    const [n, ...o] = s.split(": "), a = o.join(": ");
    t.append(n, a);
  }
  return t;
}
var Oe = Symbol("isMockedResponse"), as = we(), cs = class {
  constructor(e, t) {
    this.initialRequest = e, this.logger = t, this.method = "GET", this.url = null, this.events = /* @__PURE__ */ new Map(), this.requestId = lt(), this.requestHeaders = new Headers(), this.responseBuffer = new Uint8Array(), this.request = Me(e, {
      setProperty: ([r, s], n) => {
        switch (r) {
          case "ontimeout": {
            const o = r.slice(
              2
            );
            return this.request.addEventListener(o, s), n();
          }
          default:
            return n();
        }
      },
      methodCall: ([r, s], n) => {
        var o;
        switch (r) {
          case "open": {
            const [a, u] = s;
            return typeof u > "u" ? (this.method = "GET", this.url = qe(a)) : (this.method = a, this.url = qe(u)), this.logger = this.logger.extend(`${this.method} ${this.url.href}`), this.logger.info("open", this.method, this.url.href), n();
          }
          case "addEventListener": {
            const [a, u] = s;
            return this.registerEvent(a, u), this.logger.info("addEventListener", a, u), n();
          }
          case "setRequestHeader": {
            const [a, u] = s;
            return this.requestHeaders.set(a, u), this.logger.info("setRequestHeader", a, u), n();
          }
          case "send": {
            const [a] = s;
            a != null && (this.requestBody = typeof a == "string" ? _r(a) : a), this.request.addEventListener("load", () => {
              if (typeof this.onResponse < "u") {
                const c = os(
                  this.request,
                  /**
                   * The `response` property is the right way to read
                   * the ambiguous response body, as the request's "responseType" may differ.
                   * @see https://xhr.spec.whatwg.org/#the-response-attribute
                   */
                  this.request.response
                );
                this.onResponse.call(this, {
                  response: c,
                  isMockedResponse: Oe in this.request,
                  request: u,
                  requestId: this.requestId
                });
              }
            });
            const u = this.toFetchApiRequest();
            (((o = this.onRequest) == null ? void 0 : o.call(this, {
              request: u,
              requestId: this.requestId
            })) || Promise.resolve()).finally(() => {
              if (this.request.readyState < this.request.LOADING)
                return this.logger.info(
                  "request callback settled but request has not been handled (readystate %d), performing as-is...",
                  this.request.readyState
                ), as && this.request.setRequestHeader("X-Request-Id", this.requestId), n();
            });
            break;
          }
          default:
            return n();
        }
      }
    });
  }
  registerEvent(e, t) {
    const s = (this.events.get(e) || []).concat(t);
    this.events.set(e, s), this.logger.info('registered event "%s"', e, t);
  }
  /**
   * Responds to the current request with the given
   * Fetch API `Response` instance.
   */
  respondWith(e) {
    this.logger.info(
      "responding with a mocked response: %d %s",
      e.status,
      e.statusText
    ), q(this.request, Oe, !0), q(this.request, "status", e.status), q(this.request, "statusText", e.statusText), q(this.request, "responseURL", this.url.href), this.request.getResponseHeader = new Proxy(this.request.getResponseHeader, {
      apply: (s, n, o) => {
        if (this.logger.info("getResponseHeader", o[0]), this.request.readyState < this.request.HEADERS_RECEIVED)
          return this.logger.info("headers not received yet, returning null"), null;
        const a = e.headers.get(o[0]);
        return this.logger.info(
          'resolved response header "%s" to',
          o[0],
          a
        ), a;
      }
    }), this.request.getAllResponseHeaders = new Proxy(
      this.request.getAllResponseHeaders,
      {
        apply: () => {
          if (this.logger.info("getAllResponseHeaders"), this.request.readyState < this.request.HEADERS_RECEIVED)
            return this.logger.info("headers not received yet, returning empty string"), "";
          const n = Array.from(e.headers.entries()).map(([o, a]) => `${o}: ${a}`).join(`\r
`);
          return this.logger.info("resolved all response headers to", n), n;
        }
      }
    ), Object.defineProperties(this.request, {
      response: {
        enumerable: !0,
        configurable: !1,
        get: () => this.response
      },
      responseText: {
        enumerable: !0,
        configurable: !1,
        get: () => this.responseText
      },
      responseXML: {
        enumerable: !0,
        configurable: !1,
        get: () => this.responseXML
      }
    });
    const t = e.headers.has("Content-Length") ? Number(e.headers.get("Content-Length")) : (
      /**
       * @todo Infer the response body length from the response body.
       */
      void 0
    );
    this.logger.info("calculated response body length", t), this.trigger("loadstart", {
      loaded: 0,
      total: t
    }), this.setReadyState(this.request.HEADERS_RECEIVED), this.setReadyState(this.request.LOADING);
    const r = () => {
      this.logger.info("finalizing the mocked response..."), this.setReadyState(this.request.DONE), this.trigger("load", {
        loaded: this.responseBuffer.byteLength,
        total: t
      }), this.trigger("loadend", {
        loaded: this.responseBuffer.byteLength,
        total: t
      });
    };
    if (e.body) {
      this.logger.info("mocked response has body, streaming...");
      const s = e.body.getReader(), n = async () => {
        const { value: o, done: a } = await s.read();
        if (a) {
          this.logger.info("response body stream done!"), r();
          return;
        }
        o && (this.logger.info("read response body chunk:", o), this.responseBuffer = Kr(this.responseBuffer, o), this.trigger("progress", {
          loaded: this.responseBuffer.byteLength,
          total: t
        })), n();
      };
      n();
    } else
      r();
  }
  responseBufferToText() {
    return Lr(this.responseBuffer);
  }
  get response() {
    if (this.logger.info(
      "getResponse (responseType: %s)",
      this.request.responseType
    ), this.request.readyState !== this.request.DONE)
      return null;
    switch (this.request.responseType) {
      case "json": {
        const e = ns(this.responseBufferToText());
        return this.logger.info("resolved response JSON", e), e;
      }
      case "arraybuffer": {
        const e = Tr(this.responseBuffer);
        return this.logger.info("resolved response ArrayBuffer", e), e;
      }
      case "blob": {
        const e = this.request.getResponseHeader("Content-Type") || "text/plain", t = new Blob([this.responseBufferToText()], {
          type: e
        });
        return this.logger.info(
          "resolved response Blob (mime type: %s)",
          t,
          e
        ), t;
      }
      default: {
        const e = this.responseBufferToText();
        return this.logger.info(
          'resolving "%s" response type as text',
          this.request.responseType,
          e
        ), e;
      }
    }
  }
  get responseText() {
    if (O(
      this.request.responseType === "" || this.request.responseType === "text",
      "InvalidStateError: The object is in invalid state."
    ), this.request.readyState !== this.request.LOADING && this.request.readyState !== this.request.DONE)
      return "";
    const e = this.responseBufferToText();
    return this.logger.info('getResponseText: "%s"', e), e;
  }
  get responseXML() {
    if (O(
      this.request.responseType === "" || this.request.responseType === "document",
      "InvalidStateError: The object is in invalid state."
    ), this.request.readyState !== this.request.DONE)
      return null;
    const e = this.request.getResponseHeader("Content-Type") || "";
    return typeof DOMParser > "u" ? (console.warn(
      "Cannot retrieve XMLHttpRequest response body as XML: DOMParser is not defined. You are likely using an environment that is not browser or does not polyfill browser globals correctly."
    ), null) : ss(e) ? new DOMParser().parseFromString(
      this.responseBufferToText(),
      e
    ) : null;
  }
  errorWith(e) {
    this.logger.info("responding with an error"), this.setReadyState(this.request.DONE), this.trigger("error"), this.trigger("loadend");
  }
  /**
   * Transitions this request's `readyState` to the given one.
   */
  setReadyState(e) {
    if (this.logger.info(
      "setReadyState: %d -> %d",
      this.request.readyState,
      e
    ), this.request.readyState === e) {
      this.logger.info("ready state identical, skipping transition...");
      return;
    }
    q(this.request, "readyState", e), this.logger.info("set readyState to: %d", e), e !== this.request.UNSENT && (this.logger.info('triggerring "readystatechange" event...'), this.trigger("readystatechange"));
  }
  /**
   * Triggers given event on the `XMLHttpRequest` instance.
   */
  trigger(e, t) {
    const r = this.request[`on${e}`], s = ts(this.request, e, t);
    this.logger.info('trigger "%s"', e, t || ""), typeof r == "function" && (this.logger.info('found a direct "%s" callback, calling...', e), r.call(this.request, s));
    for (const [n, o] of this.events)
      n === e && (this.logger.info(
        'found %d listener(s) for "%s" event, calling...',
        o.length,
        e
      ), o.forEach((a) => a.call(this.request, s)));
  }
  /**
   * Converts this `XMLHttpRequest` instance into a Fetch API `Request` instance.
   */
  toFetchApiRequest() {
    this.logger.info("converting request to a Fetch API Request...");
    const e = new Request(this.url.href, {
      method: this.method,
      headers: this.requestHeaders,
      /**
       * @see https://xhr.spec.whatwg.org/#cross-origin-credentials
       */
      credentials: this.request.withCredentials ? "include" : "same-origin",
      body: ["GET", "HEAD"].includes(this.method) ? null : this.requestBody
    }), t = Me(e.headers, {
      methodCall: ([r, s], n) => {
        switch (r) {
          case "append":
          case "set": {
            const [o, a] = s;
            this.request.setRequestHeader(o, a);
            break;
          }
          case "delete": {
            const [o] = s;
            console.warn(
              `XMLHttpRequest: Cannot remove a "${o}" header from the Fetch API representation of the "${e.method} ${e.url}" request. XMLHttpRequest headers cannot be removed.`
            );
            break;
          }
        }
        return n();
      }
    });
    return q(e, "headers", t), this.logger.info("converted request to a Fetch API Request!", e), e;
  }
};
function qe(e) {
  return typeof location > "u" ? new URL(e) : new URL(e.toString(), location.href);
}
function q(e, t, r) {
  Reflect.defineProperty(e, t, {
    // Ensure writable properties to allow redefining readonly properties.
    writable: !0,
    enumerable: !0,
    value: r
  });
}
function ls({
  emitter: e,
  logger: t
}) {
  return new Proxy(globalThis.XMLHttpRequest, {
    construct(s, n, o) {
      t.info("constructed new XMLHttpRequest");
      const a = Reflect.construct(s, n, o), u = Object.getOwnPropertyDescriptors(
        s.prototype
      );
      for (const c in u)
        Reflect.defineProperty(
          a,
          c,
          u[c]
        );
      const i = new cs(
        a,
        t
      );
      return i.onRequest = async function({ request: c, requestId: l }) {
        const { interactiveRequest: h, requestController: d } = ut(c);
        this.logger.info("awaiting mocked response..."), e.once("request", ({ requestId: f }) => {
          f === l && d.responsePromise.state === "pending" && d.respondWith(void 0);
        });
        const g = await be(async () => {
          this.logger.info(
            'emitting the "request" event for %s listener(s)...',
            e.listenerCount("request")
          ), await dt(e, "request", {
            request: h,
            requestId: l
          }), this.logger.info('all "request" listeners settled!');
          const f = await d.responsePromise;
          return this.logger.info("event.respondWith called with:", f), f;
        });
        if (g.error) {
          this.logger.info(
            "request listener threw an exception, aborting request...",
            g.error
          ), i.errorWith(g.error);
          return;
        }
        const p = g.data;
        if (typeof p < "u") {
          if (this.logger.info(
            "received mocked response: %d %s",
            p.status,
            p.statusText
          ), p.type === "error") {
            this.logger.info(
              "received a network error response, rejecting the request promise..."
            ), i.errorWith(new TypeError("Network error"));
            return;
          }
          return i.respondWith(p);
        }
        this.logger.info(
          "no mocked response received, performing request as-is..."
        );
      }, i.onResponse = async function({
        response: c,
        isMockedResponse: l,
        request: h,
        requestId: d
      }) {
        this.logger.info(
          'emitting the "response" event for %s listener(s)...',
          e.listenerCount("response")
        ), e.emit("response", {
          response: c,
          isMockedResponse: l,
          request: h,
          requestId: d
        });
      }, i.request;
    }
  });
}
var mt = class extends Ee {
  constructor() {
    super(mt.interceptorSymbol);
  }
  checkEnvironment() {
    return typeof globalThis.XMLHttpRequest < "u";
  }
  setup() {
    const e = this.logger.extend("setup");
    e.info('patching "XMLHttpRequest" module...');
    const t = globalThis.XMLHttpRequest;
    O(
      !t[U],
      'Failed to patch the "XMLHttpRequest" module: already patched.'
    ), globalThis.XMLHttpRequest = ls({
      emitter: this.emitter,
      logger: this.logger
    }), e.info(
      'native "XMLHttpRequest" module patched!',
      globalThis.XMLHttpRequest.name
    ), Object.defineProperty(globalThis.XMLHttpRequest, U, {
      enumerable: !0,
      configurable: !0,
      value: !0
    }), this.subscriptions.push(() => {
      Object.defineProperty(globalThis.XMLHttpRequest, U, {
        value: void 0
      }), globalThis.XMLHttpRequest = t, e.info(
        'native "XMLHttpRequest" module restored!',
        globalThis.XMLHttpRequest.name
      );
    });
  }
}, vt = mt;
vt.interceptorSymbol = Symbol("xhr");
function us(e, t) {
  const r = new fe({
    name: "fallback",
    interceptors: [new ft(), new vt()]
  });
  return r.on("request", async ({ request: s, requestId: n }) => {
    const o = s.clone(), a = await Qe(
      s,
      n,
      e.getRequestHandlers(),
      t,
      e.emitter,
      {
        onMockedResponse(u, { handler: i, parsedResult: c }) {
          t.quiet || e.emitter.once("response:mocked", ({ response: l }) => {
            i.log({
              request: o,
              response: l,
              parsedResult: c
            });
          });
        }
      }
    );
    a && s.respondWith(a);
  }), r.on(
    "response",
    ({ response: s, isMockedResponse: n, request: o, requestId: a }) => {
      e.emitter.emit(
        n ? "response:mocked" : "response:bypass",
        {
          response: s,
          request: o,
          requestId: a
        }
      );
    }
  ), r.apply(), r;
}
function ds(e) {
  return async function(r) {
    e.fallbackInterceptor = us(
      e,
      r
    ), rt({
      message: "Mocking enabled (fallback mode).",
      quiet: r.quiet
    });
  };
}
function hs(e) {
  return function() {
    var r, s;
    (r = e.fallbackInterceptor) == null || r.dispose(), at({ quiet: (s = e.startOptions) == null ? void 0 : s.quiet });
  };
}
function fs() {
  try {
    const e = new ReadableStream({
      start: (r) => r.close()
    });
    return new MessageChannel().port1.postMessage(e, [e]), !0;
  } catch {
    return !1;
  }
}
var ps = class extends dr {
  constructor(...t) {
    super(...t);
    E(this, "context");
    E(this, "startHandler", null);
    E(this, "stopHandler", null);
    E(this, "listeners");
    O(
      !we(),
      k.formatMessage(
        "Failed to execute `setupWorker` in a non-browser environment. Consider using `setupServer` for Node.js environment instead."
      )
    ), this.listeners = [], this.context = this.createWorkerContext();
  }
  createWorkerContext() {
    const t = {
      // Mocking is not considered enabled until the worker
      // signals back the successful activation event.
      isMockingEnabled: !1,
      startOptions: null,
      worker: null,
      getRequestHandlers: () => this.handlersController.currentHandlers(),
      registration: null,
      requests: /* @__PURE__ */ new Map(),
      emitter: this.emitter,
      workerChannel: {
        on: (r, s) => {
          this.context.events.addListener(navigator.serviceWorker, "message", (n) => {
            if (n.source !== this.context.worker)
              return;
            const o = n.data;
            o && o.type === r && s(n, o);
          });
        },
        send: (r) => {
          var s;
          (s = this.context.worker) == null || s.postMessage(r);
        }
      },
      events: {
        addListener: (r, s, n) => (r.addEventListener(s, n), this.listeners.push({
          eventType: s,
          target: r,
          callback: n
        }), () => {
          r.removeEventListener(s, n);
        }),
        removeAllListeners: () => {
          for (const { target: r, eventType: s, callback: n } of this.listeners)
            r.removeEventListener(s, n);
          this.listeners = [];
        },
        once: (r) => {
          const s = [];
          return new Promise((n, o) => {
            const a = (u) => {
              try {
                const i = u.data;
                i.type === r && n(i);
              } catch (i) {
                o(i);
              }
            };
            s.push(
              this.context.events.addListener(
                navigator.serviceWorker,
                "message",
                a
              ),
              this.context.events.addListener(
                navigator.serviceWorker,
                "messageerror",
                o
              )
            );
          }).finally(() => {
            s.forEach((n) => n());
          });
        }
      },
      supports: {
        serviceWorkerApi: !("serviceWorker" in navigator) || location.protocol === "file:",
        readableStreamTransfer: fs()
      }
    };
    return this.startHandler = t.supports.serviceWorkerApi ? ds(t) : Gr(t), this.stopHandler = t.supports.serviceWorkerApi ? hs(t) : Vr(t), t;
  }
  async start(t = {}) {
    return t.waitUntilReady === !0 && k.warn(
      'The "waitUntilReady" option has been deprecated. Please remove it from this "worker.start()" call. Follow the recommended Browser integration (https://mswjs.io/docs/integrations/browser) to eliminate any race conditions between the Service Worker registration and any requests made by your application on initial render.'
    ), this.context.startOptions = et(
      Xr,
      t
    ), await this.startHandler(this.context.startOptions, t);
  }
  stop() {
    super.dispose(), this.context.events.removeAllListeners(), this.context.emitter.removeAllListeners(), this.stopHandler();
  }
};
function gs(...e) {
  return new ps(...e);
}
function ms() {
  X(
    typeof URL < "u",
    k.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
function vs(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
function ys(e) {
  return e < 300 ? "#69AB32" : e < 400 ? "#F0BB4B" : "#E95F5D";
}
function ws() {
  const e = /* @__PURE__ */ new Date();
  return [e.getHours(), e.getMinutes(), e.getSeconds()].map(String).map((t) => t.slice(0, 2)).map((t) => t.padStart(2, "0")).join(":");
}
async function bs(e) {
  const r = await e.clone().text();
  return {
    url: new URL(e.url),
    method: e.method,
    headers: Object.fromEntries(e.headers.entries()),
    body: r
  };
}
var Es = Object.create, yt = Object.defineProperty, ks = Object.getOwnPropertyDescriptor, wt = Object.getOwnPropertyNames, xs = Object.getPrototypeOf, Rs = Object.prototype.hasOwnProperty, bt = (e, t) => function() {
  return t || (0, e[wt(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Ss = (e, t, r, s) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of wt(t))
      !Rs.call(e, n) && n !== r && yt(e, n, { get: () => t[n], enumerable: !(s = ks(t, n)) || s.enumerable });
  return e;
}, _s = (e, t, r) => (r = e != null ? Es(xs(e)) : {}, Ss(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? yt(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), Ls = bt({
  "node_modules/statuses/codes.json"(e, t) {
    t.exports = {
      100: "Continue",
      101: "Switching Protocols",
      102: "Processing",
      103: "Early Hints",
      200: "OK",
      201: "Created",
      202: "Accepted",
      203: "Non-Authoritative Information",
      204: "No Content",
      205: "Reset Content",
      206: "Partial Content",
      207: "Multi-Status",
      208: "Already Reported",
      226: "IM Used",
      300: "Multiple Choices",
      301: "Moved Permanently",
      302: "Found",
      303: "See Other",
      304: "Not Modified",
      305: "Use Proxy",
      307: "Temporary Redirect",
      308: "Permanent Redirect",
      400: "Bad Request",
      401: "Unauthorized",
      402: "Payment Required",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      407: "Proxy Authentication Required",
      408: "Request Timeout",
      409: "Conflict",
      410: "Gone",
      411: "Length Required",
      412: "Precondition Failed",
      413: "Payload Too Large",
      414: "URI Too Long",
      415: "Unsupported Media Type",
      416: "Range Not Satisfiable",
      417: "Expectation Failed",
      418: "I'm a Teapot",
      421: "Misdirected Request",
      422: "Unprocessable Entity",
      423: "Locked",
      424: "Failed Dependency",
      425: "Too Early",
      426: "Upgrade Required",
      428: "Precondition Required",
      429: "Too Many Requests",
      431: "Request Header Fields Too Large",
      451: "Unavailable For Legal Reasons",
      500: "Internal Server Error",
      501: "Not Implemented",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      506: "Variant Also Negotiates",
      507: "Insufficient Storage",
      508: "Loop Detected",
      509: "Bandwidth Limit Exceeded",
      510: "Not Extended",
      511: "Network Authentication Required"
    };
  }
}), Ts = bt({
  "node_modules/statuses/index.js"(e, t) {
    var r = Ls();
    t.exports = u, u.message = r, u.code = s(r), u.codes = n(r), u.redirect = {
      300: !0,
      301: !0,
      302: !0,
      303: !0,
      305: !0,
      307: !0,
      308: !0
    }, u.empty = {
      204: !0,
      205: !0,
      304: !0
    }, u.retry = {
      502: !0,
      503: !0,
      504: !0
    };
    function s(i) {
      var c = {};
      return Object.keys(i).forEach(function(h) {
        var d = i[h], g = Number(h);
        c[d.toLowerCase()] = g;
      }), c;
    }
    function n(i) {
      return Object.keys(i).map(function(l) {
        return Number(l);
      });
    }
    function o(i) {
      var c = i.toLowerCase();
      if (!Object.prototype.hasOwnProperty.call(u.code, c))
        throw new Error('invalid status message: "' + i + '"');
      return u.code[c];
    }
    function a(i) {
      if (!Object.prototype.hasOwnProperty.call(u.message, i))
        throw new Error("invalid status code: " + i);
      return u.message[i];
    }
    function u(i) {
      if (typeof i == "number")
        return a(i);
      if (typeof i != "string")
        throw new TypeError("code must be a number or string");
      var c = parseInt(i, 10);
      return isNaN(c) ? o(i) : a(c);
    }
  }
}), Cs = _s(Ts(), 1), Et = Cs.default;
/*! Bundled license information:

statuses/index.js:
  (*!
   * statuses
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2016 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
const { message: Ps } = Et;
async function As(e) {
  const t = e.clone(), r = await t.text(), s = t.status || 200, n = t.statusText || Ps[s] || "OK";
  return {
    status: s,
    statusText: n,
    headers: Object.fromEntries(t.headers.entries()),
    body: r
  };
}
function Is(e) {
  for (var t = [], r = 0; r < e.length; ) {
    var s = e[r];
    if (s === "*" || s === "+" || s === "?") {
      t.push({ type: "MODIFIER", index: r, value: e[r++] });
      continue;
    }
    if (s === "\\") {
      t.push({ type: "ESCAPED_CHAR", index: r++, value: e[r++] });
      continue;
    }
    if (s === "{") {
      t.push({ type: "OPEN", index: r, value: e[r++] });
      continue;
    }
    if (s === "}") {
      t.push({ type: "CLOSE", index: r, value: e[r++] });
      continue;
    }
    if (s === ":") {
      for (var n = "", o = r + 1; o < e.length; ) {
        var a = e.charCodeAt(o);
        if (
          // `0-9`
          a >= 48 && a <= 57 || // `A-Z`
          a >= 65 && a <= 90 || // `a-z`
          a >= 97 && a <= 122 || // `_`
          a === 95
        ) {
          n += e[o++];
          continue;
        }
        break;
      }
      if (!n)
        throw new TypeError("Missing parameter name at ".concat(r));
      t.push({ type: "NAME", index: r, value: n }), r = o;
      continue;
    }
    if (s === "(") {
      var u = 1, i = "", o = r + 1;
      if (e[o] === "?")
        throw new TypeError('Pattern cannot start with "?" at '.concat(o));
      for (; o < e.length; ) {
        if (e[o] === "\\") {
          i += e[o++] + e[o++];
          continue;
        }
        if (e[o] === ")") {
          if (u--, u === 0) {
            o++;
            break;
          }
        } else if (e[o] === "(" && (u++, e[o + 1] !== "?"))
          throw new TypeError("Capturing groups are not allowed at ".concat(o));
        i += e[o++];
      }
      if (u)
        throw new TypeError("Unbalanced pattern at ".concat(r));
      if (!i)
        throw new TypeError("Missing pattern at ".concat(r));
      t.push({ type: "PATTERN", index: r, value: i }), r = o;
      continue;
    }
    t.push({ type: "CHAR", index: r, value: e[r++] });
  }
  return t.push({ type: "END", index: r, value: "" }), t;
}
function Ms(e, t) {
  t === void 0 && (t = {});
  for (var r = Is(e), s = t.prefixes, n = s === void 0 ? "./" : s, o = "[^".concat(D(t.delimiter || "/#?"), "]+?"), a = [], u = 0, i = 0, c = "", l = function(_) {
    if (i < r.length && r[i].type === _)
      return r[i++].value;
  }, h = function(_) {
    var I = l(_);
    if (I !== void 0)
      return I;
    var M = r[i], te = M.type, re = M.index;
    throw new TypeError("Unexpected ".concat(te, " at ").concat(re, ", expected ").concat(_));
  }, d = function() {
    for (var _ = "", I; I = l("CHAR") || l("ESCAPED_CHAR"); )
      _ += I;
    return _;
  }; i < r.length; ) {
    var g = l("CHAR"), p = l("NAME"), f = l("PATTERN");
    if (p || f) {
      var m = g || "";
      n.indexOf(m) === -1 && (c += m, m = ""), c && (a.push(c), c = ""), a.push({
        name: p || u++,
        prefix: m,
        suffix: "",
        pattern: f || o,
        modifier: l("MODIFIER") || ""
      });
      continue;
    }
    var v = g || l("ESCAPED_CHAR");
    if (v) {
      c += v;
      continue;
    }
    c && (a.push(c), c = "");
    var y = l("OPEN");
    if (y) {
      var m = d(), S = l("NAME") || "", b = l("PATTERN") || "", A = d();
      h("CLOSE"), a.push({
        name: S || (b ? u++ : ""),
        pattern: S && !b ? o : b,
        prefix: m,
        suffix: A,
        modifier: l("MODIFIER") || ""
      });
      continue;
    }
    h("END");
  }
  return a;
}
function Os(e, t) {
  var r = [], s = xt(e, r, t);
  return qs(s, r, t);
}
function qs(e, t, r) {
  r === void 0 && (r = {});
  var s = r.decode, n = s === void 0 ? function(o) {
    return o;
  } : s;
  return function(o) {
    var a = e.exec(o);
    if (!a)
      return !1;
    for (var u = a[0], i = a.index, c = /* @__PURE__ */ Object.create(null), l = function(d) {
      if (a[d] === void 0)
        return "continue";
      var g = t[d - 1];
      g.modifier === "*" || g.modifier === "+" ? c[g.name] = a[d].split(g.prefix + g.suffix).map(function(p) {
        return n(p, g);
      }) : c[g.name] = n(a[d], g);
    }, h = 1; h < a.length; h++)
      l(h);
    return { path: u, index: i, params: c };
  };
}
function D(e) {
  return e.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function kt(e) {
  return e && e.sensitive ? "" : "i";
}
function js(e, t) {
  if (!t)
    return e;
  for (var r = /\((?:\?<(.*?)>)?(?!\?)/g, s = 0, n = r.exec(e.source); n; )
    t.push({
      // Use parenthesized substring match if available, index otherwise
      name: n[1] || s++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    }), n = r.exec(e.source);
  return e;
}
function Ns(e, t, r) {
  var s = e.map(function(n) {
    return xt(n, t, r).source;
  });
  return new RegExp("(?:".concat(s.join("|"), ")"), kt(r));
}
function $s(e, t, r) {
  return Ds(Ms(e, r), t, r);
}
function Ds(e, t, r) {
  r === void 0 && (r = {});
  for (var s = r.strict, n = s === void 0 ? !1 : s, o = r.start, a = o === void 0 ? !0 : o, u = r.end, i = u === void 0 ? !0 : u, c = r.encode, l = c === void 0 ? function(re) {
    return re;
  } : c, h = r.delimiter, d = h === void 0 ? "/#?" : h, g = r.endsWith, p = g === void 0 ? "" : g, f = "[".concat(D(p), "]|$"), m = "[".concat(D(d), "]"), v = a ? "^" : "", y = 0, S = e; y < S.length; y++) {
    var b = S[y];
    if (typeof b == "string")
      v += D(l(b));
    else {
      var A = D(l(b.prefix)), _ = D(l(b.suffix));
      if (b.pattern)
        if (t && t.push(b), A || _)
          if (b.modifier === "+" || b.modifier === "*") {
            var I = b.modifier === "*" ? "?" : "";
            v += "(?:".concat(A, "((?:").concat(b.pattern, ")(?:").concat(_).concat(A, "(?:").concat(b.pattern, "))*)").concat(_, ")").concat(I);
          } else
            v += "(?:".concat(A, "(").concat(b.pattern, ")").concat(_, ")").concat(b.modifier);
        else
          b.modifier === "+" || b.modifier === "*" ? v += "((?:".concat(b.pattern, ")").concat(b.modifier, ")") : v += "(".concat(b.pattern, ")").concat(b.modifier);
      else
        v += "(?:".concat(A).concat(_, ")").concat(b.modifier);
    }
  }
  if (i)
    n || (v += "".concat(m, "?")), v += r.endsWith ? "(?=".concat(f, ")") : "$";
  else {
    var M = e[e.length - 1], te = typeof M == "string" ? m.indexOf(M[M.length - 1]) > -1 : M === void 0;
    n || (v += "(?:".concat(m, "(?=").concat(f, "))?")), te || (v += "(?=".concat(m, "|").concat(f, ")"));
  }
  return new RegExp(v, kt(r));
}
function xt(e, t, r) {
  return e instanceof RegExp ? js(e, t) : Array.isArray(e) ? Ns(e, t, r) : $s(e, t, r);
}
new TextEncoder();
function Rt() {
  if (typeof navigator < "u" && navigator.product === "ReactNative")
    return !0;
  if (typeof process < "u") {
    const e = process.type;
    return e === "renderer" || e === "worker" ? !1 : !!(process.versions && process.versions.node);
  }
  return !1;
}
var Us = Object.defineProperty, Hs = (e, t) => {
  for (var r in t)
    Us(e, r, { get: t[r], enumerable: !0 });
}, Bs = {};
Hs(Bs, {
  blue: () => Fs,
  gray: () => Gs,
  green: () => Xs,
  red: () => Vs,
  yellow: () => Ws
});
function Ws(e) {
  return `\x1B[33m${e}\x1B[0m`;
}
function Fs(e) {
  return `\x1B[34m${e}\x1B[0m`;
}
function Gs(e) {
  return `\x1B[90m${e}\x1B[0m`;
}
function Vs(e) {
  return `\x1B[31m${e}\x1B[0m`;
}
function Xs(e) {
  return `\x1B[32m${e}\x1B[0m`;
}
Rt();
function Js(e, t = !0) {
  return [t && e.origin, e.pathname].filter(Boolean).join("");
}
const zs = /[\?|#].*$/g;
function Ys(e) {
  return new URL(`/${e}`, "http://localhost").searchParams;
}
function St(e) {
  return e.replace(zs, "");
}
function Zs(e) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
}
function Ks(e, t) {
  if (Zs(e) || e.startsWith("*"))
    return e;
  const r = t || typeof document < "u" && document.baseURI;
  return r ? (
    // Encode and decode the path to preserve escaped characters.
    decodeURI(new URL(encodeURI(e), r).href)
  ) : e;
}
function Qs(e, t) {
  if (e instanceof RegExp)
    return e;
  const r = Ks(e, t);
  return St(r);
}
function en(e) {
  return e.replace(
    /([:a-zA-Z_-]*)(\*{1,2})+/g,
    (t, r, s) => {
      const n = "(.*)";
      return r ? r.startsWith(":") ? `${r}${s}` : `${r}${n}` : n;
    }
  ).replace(/([^\/])(:)(?=\d+)/, "$1\\$2").replace(/^([^\/]+)(:)(?=\/\/)/, "$1\\$2");
}
function tn(e, t, r) {
  const s = Qs(t, r), n = typeof s == "string" ? en(s) : s, o = Js(e), a = Os(n, { decode: decodeURIComponent })(o), u = a && a.params || {};
  return {
    matches: a !== !1,
    params: u
  };
}
var rn = Object.create, _t = Object.defineProperty, sn = Object.getOwnPropertyDescriptor, Lt = Object.getOwnPropertyNames, nn = Object.getPrototypeOf, on = Object.prototype.hasOwnProperty, an = (e, t) => function() {
  return t || (0, e[Lt(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, cn = (e, t, r, s) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Lt(t))
      !on.call(e, n) && n !== r && _t(e, n, { get: () => t[n], enumerable: !(s = sn(t, n)) || s.enumerable });
  return e;
}, ln = (e, t, r) => (r = e != null ? rn(nn(e)) : {}, cn(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? _t(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), un = an({
  "node_modules/cookie/index.js"(e) {
    e.parse = s, e.serialize = n;
    var t = Object.prototype.toString, r = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
    function s(c, l) {
      if (typeof c != "string")
        throw new TypeError("argument str must be a string");
      for (var h = {}, d = l || {}, g = d.decode || o, p = 0; p < c.length; ) {
        var f = c.indexOf("=", p);
        if (f === -1)
          break;
        var m = c.indexOf(";", p);
        if (m === -1)
          m = c.length;
        else if (m < f) {
          p = c.lastIndexOf(";", f - 1) + 1;
          continue;
        }
        var v = c.slice(p, f).trim();
        if (h[v] === void 0) {
          var y = c.slice(f + 1, m).trim();
          y.charCodeAt(0) === 34 && (y = y.slice(1, -1)), h[v] = i(y, g);
        }
        p = m + 1;
      }
      return h;
    }
    function n(c, l, h) {
      var d = h || {}, g = d.encode || a;
      if (typeof g != "function")
        throw new TypeError("option encode is invalid");
      if (!r.test(c))
        throw new TypeError("argument name is invalid");
      var p = g(l);
      if (p && !r.test(p))
        throw new TypeError("argument val is invalid");
      var f = c + "=" + p;
      if (d.maxAge != null) {
        var m = d.maxAge - 0;
        if (isNaN(m) || !isFinite(m))
          throw new TypeError("option maxAge is invalid");
        f += "; Max-Age=" + Math.floor(m);
      }
      if (d.domain) {
        if (!r.test(d.domain))
          throw new TypeError("option domain is invalid");
        f += "; Domain=" + d.domain;
      }
      if (d.path) {
        if (!r.test(d.path))
          throw new TypeError("option path is invalid");
        f += "; Path=" + d.path;
      }
      if (d.expires) {
        var v = d.expires;
        if (!u(v) || isNaN(v.valueOf()))
          throw new TypeError("option expires is invalid");
        f += "; Expires=" + v.toUTCString();
      }
      if (d.httpOnly && (f += "; HttpOnly"), d.secure && (f += "; Secure"), d.priority) {
        var y = typeof d.priority == "string" ? d.priority.toLowerCase() : d.priority;
        switch (y) {
          case "low":
            f += "; Priority=Low";
            break;
          case "medium":
            f += "; Priority=Medium";
            break;
          case "high":
            f += "; Priority=High";
            break;
          default:
            throw new TypeError("option priority is invalid");
        }
      }
      if (d.sameSite) {
        var S = typeof d.sameSite == "string" ? d.sameSite.toLowerCase() : d.sameSite;
        switch (S) {
          case !0:
            f += "; SameSite=Strict";
            break;
          case "lax":
            f += "; SameSite=Lax";
            break;
          case "strict":
            f += "; SameSite=Strict";
            break;
          case "none":
            f += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return f;
    }
    function o(c) {
      return c.indexOf("%") !== -1 ? decodeURIComponent(c) : c;
    }
    function a(c) {
      return encodeURIComponent(c);
    }
    function u(c) {
      return t.call(c) === "[object Date]" || c instanceof Date;
    }
    function i(c, l) {
      try {
        return l(c);
      } catch {
        return c;
      }
    }
  }
}), dn = ln(un(), 1), pe = dn.default;
/*! Bundled license information:

cookie/index.js:
  (*!
   * cookie
   * Copyright(c) 2012-2014 Roman Shtylman
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
function je() {
  return pe.parse(document.cookie);
}
function hn(e) {
  if (typeof document > "u" || typeof location > "u")
    return {};
  switch (e.credentials) {
    case "same-origin": {
      const t = new URL(e.url);
      return location.origin === t.origin ? je() : {};
    }
    case "include":
      return je();
    default:
      return {};
  }
}
function fn(e) {
  var a;
  const t = e.headers.get("cookie"), r = t ? pe.parse(t) : {};
  K.hydrate();
  const s = Array.from((a = K.get(e)) == null ? void 0 : a.entries()).reduce((u, [i, { value: c }]) => Object.assign(u, { [i.trim()]: c }), {}), o = {
    ...hn(e),
    ...s
  };
  for (const [u, i] of Object.entries(o))
    e.headers.append("cookie", pe.serialize(u, i));
  return {
    ...o,
    ...r
  };
}
var C = /* @__PURE__ */ ((e) => (e.HEAD = "HEAD", e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.OPTIONS = "OPTIONS", e.DELETE = "DELETE", e))(C || {});
class pn extends Z {
  constructor(t, r, s, n) {
    super({
      info: {
        header: `${t} ${r}`,
        path: r,
        method: t
      },
      resolver: s,
      options: n
    }), this.checkRedundantQueryParameters();
  }
  checkRedundantQueryParameters() {
    const { method: t, path: r } = this.info;
    if (r instanceof RegExp || St(r) === r)
      return;
    Ys(r).forEach((o, a) => {
    }), k.warn(
      `Found a redundant usage of query parameters in the request handler URL for "${t} ${r}". Please match against a path instead and access query parameters in the response resolver function using "req.url.searchParams".`
    );
  }
  async parse(t) {
    var o;
    const r = new URL(t.request.url), s = tn(
      r,
      this.info.path,
      (o = t.resolutionContext) == null ? void 0 : o.baseUrl
    ), n = fn(t.request);
    return {
      match: s,
      cookies: n
    };
  }
  predicate(t) {
    const r = this.matchMethod(t.request.method), s = t.parsedResult.match.matches;
    return r && s;
  }
  matchMethod(t) {
    return this.info.method instanceof RegExp ? this.info.method.test(t) : vs(this.info.method, t);
  }
  extendResolverArgs(t) {
    var r;
    return {
      params: ((r = t.parsedResult.match) == null ? void 0 : r.params) || {},
      cookies: t.parsedResult.cookies
    };
  }
  async log(t) {
    const r = Ye(t.request.url), s = await bs(t.request), n = await As(t.response), o = ys(n.status);
    console.groupCollapsed(
      k.formatMessage(
        `${ws()} ${t.request.method} ${r} (%c${n.status} ${n.statusText}%c)`
      ),
      `color:${o}`,
      "color:inherit"
    ), console.log("Request", s), console.log("Handler:", this), console.log("Response", n), console.groupEnd();
  }
}
function T(e) {
  return (t, r, s = {}) => new pn(e, t, r, s);
}
const x = {
  all: T(/.+/),
  head: T(C.HEAD),
  get: T(C.GET),
  post: T(C.POST),
  put: T(C.PUT),
  delete: T(C.DELETE),
  patch: T(C.PATCH),
  options: T(C.OPTIONS)
};
var gn = Object.create, Tt = Object.defineProperty, mn = Object.getOwnPropertyDescriptor, Ct = Object.getOwnPropertyNames, vn = Object.getPrototypeOf, yn = Object.prototype.hasOwnProperty, wn = (e, t) => function() {
  return t || (0, e[Ct(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, bn = (e, t, r, s) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Ct(t))
      !yn.call(e, n) && n !== r && Tt(e, n, { get: () => t[n], enumerable: !(s = mn(t, n)) || s.enumerable });
  return e;
}, En = (e, t, r) => (r = e != null ? gn(vn(e)) : {}, bn(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? Tt(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), kn = wn({
  "node_modules/set-cookie-parser/lib/set-cookie.js"(e, t) {
    var r = {
      decodeValues: !0,
      map: !1,
      silent: !1
    };
    function s(i) {
      return typeof i == "string" && !!i.trim();
    }
    function n(i, c) {
      var l = i.split(";").filter(s), h = l.shift(), d = o(h), g = d.name, p = d.value;
      c = c ? Object.assign({}, r, c) : r;
      try {
        p = c.decodeValues ? decodeURIComponent(p) : p;
      } catch (m) {
        console.error(
          "set-cookie-parser encountered an error while decoding a cookie with value '" + p + "'. Set options.decodeValues to false to disable this feature.",
          m
        );
      }
      var f = {
        name: g,
        value: p
      };
      return l.forEach(function(m) {
        var v = m.split("="), y = v.shift().trimLeft().toLowerCase(), S = v.join("=");
        y === "expires" ? f.expires = new Date(S) : y === "max-age" ? f.maxAge = parseInt(S, 10) : y === "secure" ? f.secure = !0 : y === "httponly" ? f.httpOnly = !0 : y === "samesite" ? f.sameSite = S : f[y] = S;
      }), f;
    }
    function o(i) {
      var c = "", l = "", h = i.split("=");
      return h.length > 1 ? (c = h.shift(), l = h.join("=")) : l = i, { name: c, value: l };
    }
    function a(i, c) {
      if (c = c ? Object.assign({}, r, c) : r, !i)
        return c.map ? {} : [];
      if (i.headers)
        if (typeof i.headers.getSetCookie == "function")
          i = i.headers.getSetCookie();
        else if (i.headers["set-cookie"])
          i = i.headers["set-cookie"];
        else {
          var l = i.headers[Object.keys(i.headers).find(function(d) {
            return d.toLowerCase() === "set-cookie";
          })];
          !l && i.headers.cookie && !c.silent && console.warn(
            "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
          ), i = l;
        }
      if (Array.isArray(i) || (i = [i]), c = c ? Object.assign({}, r, c) : r, c.map) {
        var h = {};
        return i.filter(s).reduce(function(d, g) {
          var p = n(g, c);
          return d[p.name] = p, d;
        }, h);
      } else
        return i.filter(s).map(function(d) {
          return n(d, c);
        });
    }
    function u(i) {
      if (Array.isArray(i))
        return i;
      if (typeof i != "string")
        return [];
      var c = [], l = 0, h, d, g, p, f;
      function m() {
        for (; l < i.length && /\s/.test(i.charAt(l)); )
          l += 1;
        return l < i.length;
      }
      function v() {
        return d = i.charAt(l), d !== "=" && d !== ";" && d !== ",";
      }
      for (; l < i.length; ) {
        for (h = l, f = !1; m(); )
          if (d = i.charAt(l), d === ",") {
            for (g = l, l += 1, m(), p = l; l < i.length && v(); )
              l += 1;
            l < i.length && i.charAt(l) === "=" ? (f = !0, l = p, c.push(i.substring(h, g)), h = l) : l = g + 1;
          } else
            l += 1;
        (!f || l >= i.length) && c.push(i.substring(h, i.length));
      }
      return c;
    }
    t.exports = a, t.exports.parse = a, t.exports.parseString = n, t.exports.splitCookiesString = u;
  }
}), xn = En(kn()), Rn = /[^a-z0-9\-#$%&'*+.^_`|~]/i;
function F(e) {
  if (Rn.test(e) || e.trim() === "")
    throw new TypeError("Invalid character in header field name");
  return e.trim().toLowerCase();
}
var Ne = [
  `
`,
  "\r",
  "	",
  " "
], Sn = new RegExp(
  `(^[${Ne.join("")}]|$[${Ne.join("")}])`,
  "g"
);
function ie(e) {
  return e.replace(Sn, "");
}
function G(e) {
  if (typeof e != "string" || e.length === 0)
    return !1;
  for (let t = 0; t < e.length; t++) {
    const r = e.charCodeAt(t);
    if (r > 127 || !_n(r))
      return !1;
  }
  return !0;
}
function _n(e) {
  return ![
    127,
    32,
    "(",
    ")",
    "<",
    ">",
    "@",
    ",",
    ";",
    ":",
    "\\",
    '"',
    "/",
    "[",
    "]",
    "?",
    "=",
    "{",
    "}"
  ].includes(e);
}
function $e(e) {
  if (typeof e != "string" || e.trim() !== e)
    return !1;
  for (let t = 0; t < e.length; t++) {
    const r = e.charCodeAt(t);
    if (
      // NUL.
      r === 0 || // HTTP newline bytes.
      r === 10 || r === 13
    )
      return !1;
  }
  return !0;
}
var j = Symbol("normalizedHeaders"), ae = Symbol("rawHeaderNames"), De = ", ", Ue, He, Ln = class Pt {
  constructor(t) {
    this[Ue] = {}, this[He] = /* @__PURE__ */ new Map(), ["Headers", "HeadersPolyfill"].includes(t == null ? void 0 : t.constructor.name) || t instanceof Pt || typeof globalThis.Headers < "u" && t instanceof globalThis.Headers ? t.forEach((s, n) => {
      this.append(n, s);
    }, this) : Array.isArray(t) ? t.forEach(([r, s]) => {
      this.append(
        r,
        Array.isArray(s) ? s.join(De) : s
      );
    }) : t && Object.getOwnPropertyNames(t).forEach((r) => {
      const s = t[r];
      this.append(
        r,
        Array.isArray(s) ? s.join(De) : s
      );
    });
  }
  [(Ue = j, He = ae, Symbol.iterator)]() {
    return this.entries();
  }
  *keys() {
    for (const [t] of this.entries())
      yield t;
  }
  *values() {
    for (const [, t] of this.entries())
      yield t;
  }
  *entries() {
    let t = Object.keys(this[j]).sort(
      (r, s) => r.localeCompare(s)
    );
    for (const r of t)
      if (r === "set-cookie")
        for (const s of this.getSetCookie())
          yield [r, s];
      else
        yield [r, this.get(r)];
  }
  /**
   * Returns a boolean stating whether a `Headers` object contains a certain header.
   */
  has(t) {
    if (!G(t))
      throw new TypeError(`Invalid header name "${t}"`);
    return this[j].hasOwnProperty(F(t));
  }
  /**
   * Returns a `ByteString` sequence of all the values of a header with a given name.
   */
  get(t) {
    if (!G(t))
      throw TypeError(`Invalid header name "${t}"`);
    return this[j][F(t)] ?? null;
  }
  /**
   * Sets a new value for an existing header inside a `Headers` object, or adds the header if it does not already exist.
   */
  set(t, r) {
    if (!G(t) || !$e(r))
      return;
    const s = F(t), n = ie(r);
    this[j][s] = ie(n), this[ae].set(s, t);
  }
  /**
   * Appends a new value onto an existing header inside a `Headers` object, or adds the header if it does not already exist.
   */
  append(t, r) {
    if (!G(t) || !$e(r))
      return;
    const s = F(t), n = ie(r);
    let o = this.has(s) ? `${this.get(s)}, ${n}` : n;
    this.set(t, o);
  }
  /**
   * Deletes a header from the `Headers` object.
   */
  delete(t) {
    if (!G(t) || !this.has(t))
      return;
    const r = F(t);
    delete this[j][r], this[ae].delete(r);
  }
  /**
   * Traverses the `Headers` object,
   * calling the given callback for each header.
   */
  forEach(t, r) {
    for (const [s, n] of this.entries())
      t.call(r, n, s, this);
  }
  /**
   * Returns an array containing the values
   * of all Set-Cookie headers associated
   * with a response
   */
  getSetCookie() {
    const t = this.get("set-cookie");
    return t === null ? [] : t === "" ? [""] : (0, xn.splitCookiesString)(t);
  }
};
const { message: Tn } = Et;
function N(e = {}) {
  const t = (e == null ? void 0 : e.status) || 200, r = (e == null ? void 0 : e.statusText) || Tn[t] || "", s = new Headers(e == null ? void 0 : e.headers);
  return {
    ...e,
    headers: s,
    status: t,
    statusText: r
  };
}
function Cn(e, t) {
  if (t.type && Object.defineProperty(e, "type", {
    value: t.type,
    enumerable: !0,
    writable: !1
  }), typeof document < "u") {
    const r = Ln.prototype.getSetCookie.call(
      t.headers
    );
    for (const s of r)
      document.cookie = s;
  }
  return e;
}
class w extends Response {
  constructor(t, r) {
    const s = N(r);
    super(t, s), Cn(this, s);
  }
  /**
   * Create a `Response` with a `Content-Type: "text/plain"` body.
   * @example
   * HttpResponse.text('hello world')
   * HttpResponse.text('Error', { status: 500 })
   */
  static text(t, r) {
    const s = N(r);
    return s.headers.has("Content-Type") || s.headers.set("Content-Type", "text/plain"), s.headers.has("Content-Length") || s.headers.set(
      "Content-Length",
      t ? new Blob([t]).size.toString() : "0"
    ), new w(t, s);
  }
  /**
   * Create a `Response` with a `Content-Type: "application/json"` body.
   * @example
   * HttpResponse.json({ firstName: 'John' })
   * HttpResponse.json({ error: 'Not Authorized' }, { status: 401 })
   */
  static json(t, r) {
    const s = N(r);
    s.headers.has("Content-Type") || s.headers.set("Content-Type", "application/json");
    const n = JSON.stringify(t);
    return s.headers.has("Content-Length") || s.headers.set(
      "Content-Length",
      n ? new Blob([n]).size.toString() : "0"
    ), new w(
      n,
      s
    );
  }
  /**
   * Create a `Response` with a `Content-Type: "application/xml"` body.
   * @example
   * HttpResponse.xml(`<user name="John" />`)
   * HttpResponse.xml(`<article id="abc-123" />`, { status: 201 })
   */
  static xml(t, r) {
    const s = N(r);
    return s.headers.has("Content-Type") || s.headers.set("Content-Type", "text/xml"), new w(t, s);
  }
  /**
   * Create a `Response` with an `ArrayBuffer` body.
   * @example
   * const buffer = new ArrayBuffer(3)
   * const view = new Uint8Array(buffer)
   * view.set([1, 2, 3])
   *
   * HttpResponse.arrayBuffer(buffer)
   */
  static arrayBuffer(t, r) {
    const s = N(r);
    return t && s.headers.set("Content-Length", t.byteLength.toString()), new w(t, s);
  }
  /**
   * Create a `Response` with a `FormData` body.
   * @example
   * const data = new FormData()
   * data.set('name', 'Alice')
   *
   * HttpResponse.formData(data)
   */
  static formData(t, r) {
    return new w(t, N(r));
  }
}
const ce = 2147483647, Be = 100, Pn = 400, An = 5;
function We() {
  return Rt() ? An : Math.floor(
    Math.random() * (Pn - Be) + Be
  );
}
async function ee(e) {
  let t;
  if (typeof e == "string")
    switch (e) {
      case "infinite": {
        t = ce;
        break;
      }
      case "real": {
        t = We();
        break;
      }
      default:
        throw new Error(
          `Failed to delay a response: unknown delay mode "${e}". Please make sure you provide one of the supported modes ("real", "infinite") or a number.`
        );
    }
  else if (typeof e > "u")
    t = We();
  else {
    if (e > ce)
      throw new Error(
        `Failed to delay a response: provided delay duration (${e}) exceeds the maximum allowed duration for "setTimeout" (${ce}). This will cause the response to be returned immediately. Please use a number within the allowed range to delay the response by exact duration, or consider the "infinite" delay mode to delay the response indefinitely.`
      );
    t = e;
  }
  return new Promise((r) => setTimeout(r, t));
}
ms();
const In = {
  token: "eyJraWQiOiJ7XCJwcm92aWRlcl90eXBlXCI6XCJkYlwiLFwiYWxpYXNcIjpcImp3dF9zaWduaW5nX2tleV8yMDIxXCIsXCJ0eXBlXCI6XCJsb2NhbFwiLFwidmVyc2lvblwiOlwiMlwifSIsImFsZyI6IlJTMjU2In0.eyJzY3AiOlsiZGxzIiwiY3JlZGVzdCIsImFub255bW91cyIsImNhc2Vfb3duZXIiXSwic3ViIjoiMmM3NGIzNWItZjBkNC00ZDE4LTk4MjYtYWJhNGY2N2M2YjRmIiwib3AiOiJhY3QiLCJvcmlnaW4iOiJkbHMiLCJpc3MiOiJUUyIsImF1ZCI6ImFwaV9hcHAiLCJ0c3QiOmZhbHNlLCJzY29wZSI6WyJkbHMiLCJjcmVkZXN0IiwiYW5vbnltb3VzIiwiY2FzZV9vd25lciJdLCJjYXNlaWQiOiJkODkyMGViZC1mNTc2LTRjY2YtODMzZi1iNzA0NDNiM2JiZDUiLCJvZnIiOiJjcmVkZXN0IiwiZXhwIjoxNjY1MDY3MjM0LCJpYXQiOjE2NjUwNjAwMzQsImp0aSI6ImRmNmQ0N2Y3LTQ1NGUtNGZiYi1hZWZlLTc2YmJkNWQ4Yjg1YSJ9.Gy0QK3eT5RMxLGk_ic7cja8FWeKjgj2lAoXdcsIbAtsGG1dVLmWdZmQ43eRv5OBzV9eMfj15VFkl0wiNn6I2-YhpP0LJArGaEb9cdlZGcBB2zOqTf0vuPsjPJwaSfyPnCXYSS-Z0LXbY6zyVQCMZAHJlIWtQEWjicdHdcKxGJV2w3VhhrsGdeOwVZeoemp-LnHCB8V-6qcFjW-WaCi8qdxTcm3lHECdQ38KgEmV6fx4Dfu4FFYeSEMVS8EglUNNkFlQiGEUSRp_fh75uV-VUFrN3_Gf2pXZIxYJo05O0cI6y1ftHvqTyMI72bmC5wf-RV8m98ivX6jxPS5cse6_Mdg",
  caseId: "a7653b17-f1b0-4786-af41-a26d38172f46"
}, ge = [{
  name: le.name,
  kvkNumber: le.kvkNumber,
  id: "NL-X-123456789",
  street: "Mock Street",
  homeNumber: "1",
  pilotBank: !0,
  postalCode: "1234AB",
  city: "Mock City",
  newToTheBank: !1
}, {
  name: Re.name,
  kvkNumber: Re.kvkNumber,
  id: "NL-X-987654321",
  street: "Mock Street",
  homeNumber: "1",
  pilotBank: !0,
  postalCode: "1234AB",
  city: "Mock City",
  newToTheBank: !0
}], Fe = {
  eligible: !0,
  newToTheBank: !1,
  nonEligibilityReasons: [],
  errorCode: ""
}, Ge = {
  // stgEligible: false,
  // balloonPayments: 0,
  // leaseEligible: false,
  eligible: !0,
  scoreIsRed: !1,
  offersList: [{
    id: "968f3410-d79e-4543-b057-3e999c6fc85e",
    // showOptions: true,
    loanAmount: 1601,
    interestPercentage: 0.012,
    totalInterestCost: 19,
    totalInvoiceAmount: 1620,
    invoicesBreakdown: [{
      invoiceId: "Invoice A",
      invoiceAmount: 1620,
      invoiceDuration: 30,
      interestRate: 0.012,
      interestCost: 19,
      loanAmount: 1601,
      invoiceLoanTerm: 30,
      loanExtension: !1
    }]
  }]
}, Mn = {
  eligible: !0,
  evaluationCode: "RER_0001"
}, Ve = {
  iban: "NL00RABO0000000001",
  psd2StatusV1: "STORAGE",
  username: "1b28b6e2-9d01-4b35-9c14-1525155b1045",
  bank: "RABO",
  trackingId: "1b28b6e2-9d01-4b35-9c14-1525155b1045"
}, On = "926108919934229314", Xe = {
  accounts: [{
    clientName: "Rabobank Nederland B.V.",
    iban: "NL80RABO1127000001",
    matchState: "MATCH"
  }, {
    clientName: "Rabobank Nederland B.V.",
    iban: "NL80RABO1127000002",
    matchState: "NO_MATCH"
  }],
  bank: "RABO",
  sub: "1b28b6e2-9d01-4b35-9c14-1525155b1045"
}, qn = [{
  id: "983437195480144072",
  secret: "v4BSB81N04K57bjM1UQB7vnY_bSZ5QzYJywTkfi3Ops",
  provider_id: "4183",
  provider_code: "abn_amro_oauth_client_nl_xf",
  provider_name: "ABN AMRO (Sandbox NL)",
  daily_refresh: !0,
  customer_id: "926108919934229314",
  created_at: "2023-04-06T09:40:25Z",
  updated_at: "2023-04-06T09:40:43Z",
  last_success_at: "2023-04-06T09:40:43Z",
  status: "active",
  country_code: "XF",
  next_refresh_possible_at: "2023-04-06T09:55:43Z",
  show_consent_confirmation: !1,
  last_consent_id: "983437196050569419"
}, {
  id: "925472880282572880",
  secret: "oypYIeoOZj2VnBoiK65rNAFYHl3hhnodKdWWK4d0V2c",
  provider_id: "3834",
  provider_code: "rabobank_oauth_client_nl_xf",
  provider_name: "Rabobank (Sandbox)",
  daily_refresh: !1,
  customer_id: "926108919934229314",
  created_at: "2023-03-31T14:56:41Z",
  updated_at: "2023-03-31T14:58:46Z",
  last_success_at: "2023-03-31T14:58:46Z",
  status: "active",
  country_code: "XF",
  next_refresh_possible_at: "2023-03-31T15:13:46Z",
  show_consent_confirmation: !1,
  last_consent_id: "979247724148824178"
}], R = "https://api.fundrstruck.nl", jn = 5;
let ke = "RABO", me = !1;
const Nn = {
  RABOBANK: "RABO",
  ING: "ING",
  ABN: "ABN",
  KNAB: "KNAB",
  ASN: "ASNB",
  SNS: "SNSB",
  REGIOBANK: "RBRB",
  TRIODOS: "TRIO",
  BUNQ: "BUNQ"
}, $n = x.post(`${R}/dls-authentication/v2/authentication/invfin/third-party/:partner/tokens`, () => w.json(In, {
  status: 200
})), Dn = x.get(`${R}/dls-company-search/v1/company/search`, ({
  request: e
}) => {
  const r = new URL(e.url).searchParams.get("query") ?? "", s = !Number.isNaN(Number(r)), n = ge.filter((a) => s ? a.kvkNumber === r : a.name.toLowerCase().includes(r)), o = n.length === 0 ? ge : n;
  return w.json(o, {
    status: 200
  });
}), Un = x.post(`${R}/dls-invoice-finance-api/v5/requester-eligibility`, async ({
  request: e
}) => {
  const t = await e.json(), {
    kvkNumber: r
  } = t, [s] = ge.filter((o) => o.kvkNumber === r), n = (s == null ? void 0 : s.newToTheBank) ?? !1;
  return Fe.newToTheBank = n, w.json(Fe, {
    status: 200
  });
}), Hn = x.post(`${R}/dls-nh-ocr-integration/v1/parse-document`, () => {
  const e = Mt({
    amount: 1e6,
    issueDate: /* @__PURE__ */ new Date(),
    invoiceId: "Invoice A",
    period: 30,
    debtorName: "",
    debtorKvk: "",
    companyName: "",
    companyKvk: le.kvkNumber
  });
  return w.json(e, {
    status: 200
  });
}), Bn = x.post(`${R}/dls-invoice-finance-api/v5/invoices`, () => {
  const e = ze();
  return w.json(e, {
    status: 200
  });
}), Wn = x.put(`${R}/dls-invoice-finance-api/v5/invoice/:trackingId`, () => {
  const e = ze();
  return w.json(e, {
    status: 200
  });
}), Fn = x.delete(`${R}/dls-invoice-finance-api/v5/invoice/:id`, async () => (await ee(2e3), new w(null, {
  status: 204
}))), Gn = x.post(`${R}/dls-transaction-processing/v1/financials/consent`, () => new w(null, {
  status: 204
})), Vn = x.post(`${R}/dls-psd2-aggregator/v1/create/session`, async ({
  request: e
}) => {
  const t = await e.json(), {
    returnUrl: r,
    bankToConnect: s
  } = t;
  ke = Nn[s], s === "REGIOBANK" && (me = !0);
  const n = /* @__PURE__ */ new Date();
  n.setDate(n.getDate() + jn);
  const o = n.toISOString(), a = {
    connectUrl: r,
    customer: On,
    expiresAt: o
  };
  return await ee(2e3), w.json(a, {
    status: 200
  });
}), Xn = x.get(`${R}/dls-psd2-aggregator/v1/fetch/connections`, () => w.json({
  connections: qn
}, {
  status: 200
})), Jn = x.get(`${R}/dls-psd2-aggregator/v1/fetch/connection/:id`, async () => (await ee(2e3), w.json({
  finished: !0
}, {
  status: 200
}))), zn = x.post(`${R}/dls-psd2-aggregator/v2/fetch/transactions`, () => (Xe.bank = ke, w.json(Xe, {
  status: 200
}))), Yn = x.get(`${R}/dls-transaction-processing/v1/financials/psd2/status`, () => (Ve.bank = ke, w.json(Ve, {
  status: 200
}))), Zn = x.post(`${R}/dls-transaction-processing/v3/financials/confirm`, () => new w(null, {
  status: 204
})), Kn = x.post(`${R}/dls-invoice-finance-api/v5/risk-evaluation`, () => w.json(Mn, {
  status: 200
})), Qn = x.get(`${R}/dls-invoice-finance-api/v5/offers`, async () => {
  Ge.scoreIsRed = me;
  const t = me ? {
    errorCode: "ERR_6001"
  } : Ge;
  return await ee(2e3), w.json(t, {
    status: 200
  });
}), eo = x.post(`${R}/dls-invoice-finance-api/v5/survey-eligibility`, () => w.json({
  eligible: !0,
  message: "[]"
}, {
  status: 200
})), to = x.post(`${R}/dls-invoice-finance-api/v5/confirm-offer`, () => new w(null, {
  status: 202
})), ro = x.post(`${R}/dls-invoice-finance-api/v5/contact-details`, () => new w(null, {
  status: 202
})), so = [$n, Dn, Un, Hn, Bn, Wn, Fn, Gn, Vn, Xn, Jn, zn, Yn, Zn, Kn, Qn, eo, to, ro], lo = gs(...so);
export {
  lo as worker
};
